<template>
  <div>
    <!--
    <b-card no-body >
      <b-card-body>
        <span>Programación de Fertilización</span>
      </b-card-body>
    </b-card>
    -->

    <b-row>
      <b-col xl="6" lg="12">
        <b-card no-body v-if="mostrarSemAct">
          <b-card-body class="px-1 pb-0 pt-1">
            <b-row>
              <b-col xl="1" lg="1" md="1" class="mb-1" align="center">
                <b-button-group>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      @click="mostrarSemAct = false"
                      id="btn_back"
                      v-b-tooltip.hover="'Regresar'"
                  >
                    <font-awesome-icon icon="fa-solid fa-arrow-left-long"/>
                  </b-button>
                </b-button-group>
              </b-col>
              <b-col xl="11" lg="11" md="1" class="mb-1" align="center">
                <span class="font-weight-bolder font-small-4" style="vertical-align: -webkit-baseline-middle!important;">{{`Detalle de registro - Total: ${this.items_sem_act.length}` }}</span>
              </b-col>

              <!--
              <b-col lg="8" class="mb-1">
                <b-form-group
                    label-for="filterInput"
                >
                  <b-form-file
                      v-if="$can('create', 'Pr Fert Programacion')"
                      id="file-small"
                      accept=".xlsx"
                      placeholder="Seleccionar Archivo Excel (.xlsx)"
                      v-model="archivo_excel"
                      ref="fileinput"
                      size="sm"
                  >
                    <template
                        slot="file-name"
                        slot-scope="{ names }"
                    >
                      <b-badge variant="primary">
                        {{ names[0] }}
                      </b-badge>
                    </template>
                  </b-form-file>
                </b-form-group>
              </b-col>
              <b-col lg="3">
                <b-form-group
                    label-for="filterInput"
                    class="mb-0"
                >
                  <b-button
                      v-if="$can('create', 'Pr Fert Programacion')"
                      variant="gradient-primary"
                      size="sm"
                      class="mr-1"
                      @click="enviarFile"
                      block
                      :disabled="!archivo_excel || loadingIMP"
                  >
                    <feather-icon
                        :icon="loadingIMP ? 'RotateCwIcon' : 'ExternalLinkIcon'"
                        size="15"
                        :class="loadingIMP ? 'spinner' : ''"
                    />
                    <span v-if="loadingIMP">&emsp13;Enviando ...</span>
                    <span v-else>&emsp13;Enviar</span>

                  </b-button>
                </b-form-group>
              </b-col>
              -->

              <!--
              <b-col xl="3" lg="6" md="6" sm="6" class="mb-1">
                <v-select
                    id="semana_btn"
                    v-model="semanaFiltro"
                    :options="semanasFiltro"
                    placeholder="Semana..."
                    class="select-size-sm"
                    @input="filtros"
                    :clearable="false"
                />
              </b-col>
              <b-col xl="5" lg="12" md="12" sm="12" class="mb-1">
                <v-select
                    id="empresa_btn"
                    v-model="empresaFiltro"
                    :options="empresasFiltro"
                    placeholder="Seleccionar empresa..."
                    class="select-size-sm"
                    @input="filtros"
                />
              </b-col>
              -->

              <!--
              <b-col lg="12" class="mt-1" align="center">
                <b-form-group
                    label-for="filterInput"
                    class="mb-0"
                >
                  <span class="text-bold font-weight-bold">Semana {{ this.semana }} - Del {{ this.inicioSemana }} al {{ this.finSemana }} </span>
                </b-form-group>
              </b-col>
              -->
            </b-row>
          </b-card-body>

          <b-table
              v-if="$can('read', 'Pr Fert Programacion')"
              ref="tableDetalleSemanaActual"
              responsive
              hover
              outlined
              small
              sticky-header="58vh"
              class="position-relative tablaferti"
              :items="items_sem_act"
              :fields="fields_detalle_SemAct"
              :busy="loading"
              show-empty
              empty-text="No se encontraron datos en esta tabla."
          >
            <template #table-busy>
              <div class="text-center text-dark my-1">
                <b-spinner class="align-middle"></b-spinner> &emsp;
                <strong>Obteniendo datos...</strong>
              </div>
            </template>

            <template #cell(accionesdos)="data" v-if="this.responsable[0].rol === 'ADMINISTRADOR' || this.responsable[0].rol === 'USUARIO'">
              <div class="text-nowrap">
                <feather-icon
                    v-if="$can('update', 'Pr Fert Programacion')"
                    :id="`btn_${data.item.id}_editar`"
                    icon="EditIcon"
                    size="16"
                    @click="validarEditar(data.item, true)"
                    v-b-tooltip.hover="'Editar registro'"
                />
              </div>
            </template>

            <template #cell(estado)="data">
              <b-badge :variant="status[1][parseInt(data.value)]">
                {{ status[0][parseInt(data.value)] }}
              </b-badge>
            </template>

            <template #cell(created)="data">
          <span>
            {{
              new Date(data.value).toLocaleString('pe-PE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                localeMatcher: 'best fit',
                hour: '2-digit',
                minute: '2-digit',
                timeZone: 'America/Lima'
              })
            }}
          </span>
            </template>
          </b-table>
        </b-card>

        <b-card no-body v-else>
          <b-card-body class="px-1 pb-0 pt-1">
            <b-row>
              <b-col xl="3" lg="3" md="3" class="mb-1 align-self-center">
                <b-button-group>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      @click="traerFertilizaciones"
                      id="act_semAct"
                      :disabled="loading"
                      v-b-tooltip.hover="'Actualizar Tabla'"
                  >
                    <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading"/>
                  </b-button>
                  <b-button
                      v-if="$can('create', 'Pr Fert Programacion') && (this.responsable[0].rol === 'ADMINISTRADOR' || this.responsable[0].rol === 'USUARIO')"
                      variant="gradient-primary"
                      size="sm"
                      @click="modal_registro(true)"
                      id="cre_semAct"
                      :disabled="loadingSAC"
                      v-b-tooltip.hover="'Crear Registro'"
                  >
                    <font-awesome-icon v-if="loadingSAC" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-plus"/>
                  </b-button>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      v-if="$can('create', 'Pr Fert Programacion') && (this.responsable[0].rol === 'ADMINISTRADOR' || this.responsable[0].rol === 'USUARIO')"
                      @click="mostrarModalImportar(true)"
                      id="imp_semAct"
                      :disabled="loadingSAM"
                      v-b-tooltip.hover="'Importar Registros'"
                  >
                    <font-awesome-icon v-if="loadingSAM" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-file-excel"/>
                  </b-button>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      v-if="$can('authorize', 'Pr Fert Programacion')"
                      @click="descargarRegistros(true)"
                      id="imp_semAct"
                      :disabled="loadingSAD"
                      v-b-tooltip.hover="'Descargar Registros'"
                  >
                    <font-awesome-icon v-if="loadingSAD" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-download"/>
                  </b-button>
                  <!-- <b-button
                      variant="gradient-primary"
                      size="sm"
                      v-if="$can('authorize', 'Pr Fert Programacion') && this.responsable[0].rol === 'JEFE DE RIEGO'"
                      @click="descargarRegistros2(true)"
                      id="imp_semAct"
                      :disabled="loadingSAD"
                      v-b-tooltip.hover="'Descargar Registros_'"
                  >
                    <font-awesome-icon v-if="loadingSAD" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-download"/>
                  </b-button> -->
                </b-button-group>
              </b-col>
              <b-col xl="9" lg="9" md="9" class="mb-1" align="center">
                <span class="font-weight-bolder font-medium-3" style="vertical-align: -webkit-baseline-middle!important;">{{`Semana actual N° ${this.semana}`}}</span><br>
                <span class="font-weight-bolder font-small-4" style="vertical-align: -webkit-baseline-middle!important;">{{`Del ${this.inicioSemana} al ${this.finSemana}` }}</span>
              </b-col>
            </b-row>
          </b-card-body>

          <b-table
              v-if="$can('read', 'Pr Fert Programacion')"
              ref="tableSemanaActual"
              responsive
              hover
              outlined
              small
              sticky-header="58vh"
              class="position-relative tablaferti"
              :items="items"
              :fields="fields"
              :filter="filter"
              :filter-included-fields="filterOn"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              @filtered="cPaginacion"
              :busy="loading"
              show-empty
              empty-text="No se encontraron datos en esta tabla."
              emptyFilteredText="No se encontraron datos con los parámetros ingresados."
          >
            <template #table-busy>
              <div class="text-center text-dark my-1">
                <b-spinner class="align-middle"></b-spinner> &emsp;
                <strong>Obteniendo datos...</strong>
              </div>
            </template>

            <template #cell(acciones)="data">
              <div class="text-nowrap">

                <!--
                <feather-icon
                    v-if="$can('update', 'Pr Fert Programacion')"
                    :id="`btn_${data.item.id}_editar`"
                    icon="EditIcon"
                    size="16"
                    class="mr-1"
                    @click="validarEditar(data.item)"
                />
                <b-tooltip
                    title="Editar registro"
                    :target="`btn_${data.item.id}_editar`"
                />



                <b-link
                    :to="{name: 'prfertprogramaciondetalle', params: {id: data.item}}"
                    class="mr-sm-1"
                >
                  <feather-icon
                      :id="`btn_${data.item.id}_view`"
                      icon="EyeIcon"
                      size="16"
                  />
                  <b-tooltip
                      title="Ver detalle"
                      :target="`btn_${data.item.id}_view`"
                  />
                </b-link>
                -->

                <feather-icon
                    v-if="$can('read', 'Pr Fert Programacion')"
                    :id="`btn_${data.item.id}_detalle`"
                    icon="EyeIcon"
                    size="16"
                    class="mr-1 text-primary"
                    @click="verDetalle(data.item)"
                    v-b-tooltip.hover="'Ver detalle'"
                />

                <feather-icon
                    v-if="$can('authorize', 'Pr Fert Programacion')"
                    :id="`btn_${data.item.id}_autorizar`"
                    icon="UserCheckIcon"
                    size="16"
                    @click="autorizar(data.item)"
                    v-b-tooltip.hover="'Cambiar Estado'"
                />

              </div>
            </template>

            <template #cell(estado)="data">
              <b-badge :variant="status[1][parseInt(data.value)]">
                {{ status[0][parseInt(data.value)] }}
              </b-badge>
            </template>

            <template #cell(created)="data">
          <span>
            {{
              new Date(data.value).toLocaleString('pe-PE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                localeMatcher: 'best fit',
                hour: '2-digit',
                minute: '2-digit',
                timeZone: 'America/Lima'
              })
            }}
          </span>
            </template>
          </b-table>
        </b-card>
      </b-col>
      <b-col xl="6" lg="12">
        <b-card no-body v-if="mostrarSemSgte">
          <b-card-body class="px-1 pb-0 pt-1">
            <b-row>
              <b-col xl="1" lg="1" md="1" class="mb-1" align="center">
                <b-button-group>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      @click="mostrarSemSgte = false"
                      id="btn_backSgte"
                      v-b-tooltip.hover="'Regresar'"
                  >
                    <font-awesome-icon icon="fa-solid fa-arrow-left-long"/>
                  </b-button>
                </b-button-group>
              </b-col>
              <b-col xl="11" lg="11" md="1" class="mb-1" align="center">
                <span class="font-weight-bolder font-small-4" style="vertical-align: -webkit-baseline-middle!important;">{{`Detalle de registro - Total: ${this.items_sem_sgte.length}` }}</span>
              </b-col>

              <!--
              <b-col lg="8" class="mb-1">
                <b-form-group
                    label-for="filterInput"
                >
                  <b-form-file
                      v-if="$can('create', 'Pr Fert Programacion')"
                      id="file-small"
                      accept=".xlsx"
                      placeholder="Seleccionar Archivo Excel (.xlsx)"
                      v-model="archivo_excel"
                      ref="fileinput"
                      size="sm"
                  >
                    <template
                        slot="file-name"
                        slot-scope="{ names }"
                    >
                      <b-badge variant="primary">
                        {{ names[0] }}
                      </b-badge>
                    </template>
                  </b-form-file>
                </b-form-group>
              </b-col>
              <b-col lg="3">
                <b-form-group
                    label-for="filterInput"
                    class="mb-0"
                >
                  <b-button
                      v-if="$can('create', 'Pr Fert Programacion')"
                      variant="gradient-primary"
                      size="sm"
                      class="mr-1"
                      @click="enviarFile"
                      block
                      :disabled="!archivo_excel || loadingIMP"
                  >
                    <feather-icon
                        :icon="loadingIMP ? 'RotateCwIcon' : 'ExternalLinkIcon'"
                        size="15"
                        :class="loadingIMP ? 'spinner' : ''"
                    />
                    <span v-if="loadingIMP">&emsp13;Enviando ...</span>
                    <span v-else>&emsp13;Enviar</span>

                  </b-button>
                </b-form-group>
              </b-col>
              -->

              <!--
              <b-col xl="3" lg="6" md="6" sm="6" class="mb-1">
                <v-select
                    id="semana_btn"
                    v-model="semanaFiltro"
                    :options="semanasFiltro"
                    placeholder="Semana..."
                    class="select-size-sm"
                    @input="filtros"
                    :clearable="false"
                />
              </b-col>
              <b-col xl="5" lg="12" md="12" sm="12" class="mb-1">
                <v-select
                    id="empresa_btn"
                    v-model="empresaFiltro"
                    :options="empresasFiltro"
                    placeholder="Seleccionar empresa..."
                    class="select-size-sm"
                    @input="filtros"
                />
              </b-col>
              -->

              <!--
              <b-col lg="12" class="mt-1" align="center">
                <b-form-group
                    label-for="filterInput"
                    class="mb-0"
                >
                  <span class="text-bold font-weight-bold">Semana {{ this.semana }} - Del {{ this.inicioSemana }} al {{ this.finSemana }} </span>
                </b-form-group>
              </b-col>
              -->
            </b-row>
          </b-card-body>

          <b-table
              v-if="$can('read', 'Pr Fert Programacion')"
              ref="tableDetalleSemanaSgte"
              responsive
              hover
              outlined
              small
              sticky-header="58vh"
              class="position-relative tablaferti"
              :items="items_sem_sgte"
              :fields="fields_detalle_SemAct"
              :busy="loading"
              show-empty
              empty-text="No se encontraron datos en esta tabla."
          >
            <template #table-busy>
              <div class="text-center text-dark my-1">
                <b-spinner class="align-middle"></b-spinner> &emsp;
                <strong>Obteniendo datos...</strong>
              </div>
            </template>

            <template #cell(acciones)="data">
              <div class="text-nowrap">
                <feather-icon
                    v-if="$can('update', 'Pr Fert Programacion')"
                    :id="`btn_${data.item.id}_editar`"
                    icon="EditIcon"
                    size="16"
                    @click="validarEditar(data.item, false)"
                    v-b-tooltip.hover="'Editar registro'"
                />
              </div>
            </template>

            <template #cell(estado)="data">
              <b-badge :variant="status[1][parseInt(data.value)]">
                {{ status[0][parseInt(data.value)] }}
              </b-badge>
            </template>

            <template #cell(created)="data">
          <span>
            {{
              new Date(data.value).toLocaleString('pe-PE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                localeMatcher: 'best fit',
                hour: '2-digit',
                minute: '2-digit',
                timeZone: 'America/Lima'
              })
            }}
          </span>
            </template>
          </b-table>
        </b-card>

        <b-card no-body v-else>
          <b-card-body class="px-1 pb-0 pt-1">
            <b-row>
              <b-col xl="3" lg="3" md="3" class="mb-1 align-self-center">
                <b-button-group>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      @click="traerFertilizaciones"
                      id="act_semSgte"
                      :disabled="loading"
                      v-b-tooltip.hover="'Actualizar Tabla'"
                  >
                    <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading"/>
                  </b-button>
                  <b-button
                      v-if="$can('create', 'Pr Fert Programacion') && (this.responsable[0].rol === 'ADMINISTRADOR' || this.responsable[0].rol === 'USUARIO')"
                      variant="gradient-primary"
                      size="sm"
                      @click="modal_registro(false)"
                      id="cre_semSgte"
                      :disabled="loadingSSC"
                      v-b-tooltip.hover="'Crear Registro'"
                  >
                    <font-awesome-icon v-if="loadingSSC" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-plus"/>
                  </b-button>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      v-if="$can('create', 'Pr Fert Programacion') && (this.responsable[0].rol === 'ADMINISTRADOR' || this.responsable[0].rol === 'USUARIO')"
                      @click="mostrarModalImportar(false)"
                      id="imp_semSgte"
                      :disabled="loadingSSM"
                      v-b-tooltip.hover="'Importar Registros'"
                  >
                    <font-awesome-icon v-if="loadingSSM" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-file-excel"/>
                  </b-button>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      v-if="$can('authorize', 'Pr Fert Programacion')"
                      @click="descargarRegistros(false)"
                      id="imp_semAct"
                      :disabled="loadingSSD"
                      v-b-tooltip.hover="'Descargar Registros'"
                  >
                    <font-awesome-icon v-if="loadingSSD" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-download"/>
                  </b-button>
                  <!-- <b-button
                      variant="gradient-primary"
                      size="sm"
                      v-if="$can('authorize', 'Pr Fert Programacion') && this.responsable[0].rol === 'JEFE DE RIEGO'"
                      @click="descargarRegistros2(false)"
                      id="imp_semAct"
                      :disabled="loadingSSD"
                      v-b-tooltip.hover="'Descargar Registros_'"
                  >
                    <font-awesome-icon v-if="loadingSSD" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-download"/>
                  </b-button> -->
                </b-button-group>
              </b-col>
              <b-col xl="9" lg="9" md="9" class="mb-1" align="center">
                <span class="font-weight-bolder font-medium-3" style="vertical-align: -webkit-baseline-middle!important;">{{`Semana siguiente N° ${this.semana_sig}`}}</span><br>
                <span class="font-weight-bolder font-small-4" style="vertical-align: -webkit-baseline-middle!important;">{{`Del ${this.inicioSemana_sig} al ${this.finSemana_sig}` }}</span>
              </b-col>
            </b-row>
          </b-card-body>

          <b-table
              v-if="$can('read', 'Pr Fert Programacion')"
              ref="tableSemanaActual"
              responsive
              hover
              outlined
              small
              sticky-header="58vh"
              class="position-relative tablaferti"
              :items="items"
              :fields="fields"
              :filter="filter_sig"
              :filter-included-fields="filterOn"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :busy="loading"
              show-empty
              empty-text="No se encontraron datos en esta tabla."
              emptyFilteredText="No se encontraron datos con los parámetros ingresados."
          >
            <template #table-busy>
              <div class="text-center text-dark my-1">
                <b-spinner class="align-middle"></b-spinner> &emsp;
                <strong>Obteniendo datos...</strong>
              </div>
            </template>

            <template #cell(acciones)="data">
              <div class="text-nowrap">

                <!--
                <feather-icon
                    v-if="$can('update', 'Pr Fert Programacion')"
                    :id="`btn_${data.item.id}_editar`"
                    icon="EditIcon"
                    size="16"
                    class="mr-1"
                    @click="validarEditar(data.item)"
                />
                <b-tooltip
                    title="Editar registro"
                    :target="`btn_${data.item.id}_editar`"
                />



                <b-link
                    :to="{name: 'prfertprogramaciondetalle', params: {id: data.item}}"
                    class="mr-sm-1"
                >
                  <feather-icon
                      :id="`btn_${data.item.id}_view`"
                      icon="EyeIcon"
                      size="16"
                  />
                  <b-tooltip
                      title="Ver detalle"
                      :target="`btn_${data.item.id}_view`"
                  />
                </b-link>
                -->

                <feather-icon
                    v-if="$can('read', 'Pr Fert Programacion')"
                    :id="`btn_${data.item.id}_detalle`"
                    icon="EyeIcon"
                    size="16"
                    class="mr-1 text-primary"
                    @click="verDetalleSemSgte(data.item)"
                    v-b-tooltip.hover="'Ver detalle'"
                />

                <feather-icon
                    v-if="$can('authorize', 'Pr Fert Programacion')"
                    :id="`btn_${data.item.id}_autorizar`"
                    icon="UserCheckIcon"
                    size="16"
                    @click="autorizar(data.item)"
                    v-b-tooltip.hover="'Cambiar Estado'"
                />

              </div>
            </template>

            <template #cell(estado)="data">
              <b-badge :variant="status[1][parseInt(data.value)]">
                {{ status[0][parseInt(data.value)] }}
              </b-badge>
            </template>

            <template #cell(created)="data">
              <span>
                {{
                  new Date(data.value).toLocaleString('pe-PE', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    localeMatcher: 'best fit',
                    hour: '2-digit',
                    minute: '2-digit',
                    timeZone: 'America/Lima'
                  })
                }}
              </span>
            </template>
          </b-table>
        </b-card>
      </b-col>

    </b-row>

    <b-modal
        id="modal-prevent-closing"
        v-model="modal_registro_o"
        ref="my-modal"
        :title="title_sem"
        ok-title="Registrar"
        cancel-title="Cancelar"
        cancel-variant="outline-secondary"
        :size="loading2 ? 'md':'xl'"
        :cancel-disabled="loading2"
        :ok-disabled="loading2"
        centered
        no-close-on-esc
        no-close-on-backdrop
        @show="resetModal"
        @hidden="resetModal"
        @ok="handleOk"
    >
      <div v-if="loading2"  align="center">
        <p>Registrando ... </p>
        <b-spinner label="Loading..." variant="primary"/>
      </div>
      <validation-observer v-else ref="formularioFertilizacion" #default="{invalid}">
        <b-form autocomplete="off" @submit.prevent="handleSubmit">
          <b-row>
            <b-col lg="2">
              <b-form-group
                  label="Semana"
                  label-for="semana"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Semana"
                    vid="semana"
                    rules="required|integer|between:1,52"
                >
                  <b-form-input
                      id="semana"
                      v-model="semana"
                      :state="errors.length > 0 ? false:null"
                      name="semana"
                      @input="asignarInicioFinSemana"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group
                  label="Empresa"
                  label-for="empresa"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Empresa"
                    vid="empresa"
                    rules="required"
                >
                  <v-select
                      id="empresa"
                      v-model="empresa"
                      :options="empresas"
                      placeholder="Seleccionar empresa..."
                      @input="asignarCultivos"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group
                  label="Cultivo"
                  label-for="cultivo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Cultivo"
                    vid="cultivo"
                    rules="required"
                >
                  <v-select
                      id="cultivo"
                      v-model="cultivo"
                      :options="cultivos"
                      placeholder="Seleccionar cultivo..."
                      @input="asignarFundos"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group
                  label="Fundo"
                  label-for="fundo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Fundo"
                    vid="fundo"
                    rules="required"
                >
                  <v-select
                      id="fundo"
                      v-model="fundo"
                      :options="fundos"
                      placeholder="Seleccionar fundo..."
                      @input="asignarEtapas"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group
                  label="Etapa Fenológica"
                  label-for="etapa_fen"
              >
                <validation-provider
                    #default="{ errors }"
                    name="etapa_fen"
                    vid="etapa_fen"
                    rules="required"
                >
                  <v-select
                      id="etapa_fen"
                      v-model="eta_fen_seleccionada"
                      :options="etapas_fenológicas"
                      placeholder="Seleccionar etapa fenológica..."
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group
                  label="Concentracion"
                  label-for="por_concentracion"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Concentracion"
                    vid="por_concentracion"
                    rules="required|double|max:8"
                >
                  <b-form-input
                      id="por_concentracion"
                      v-model="por_concentracion"
                      :state="errors.length > 0 ? false:null"
                      name="por_concentracion"
                      placeholder="0.0"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <b-form-group
                  label="Etapa"
                  label-for="etapa"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Etapa"
                    vid="etapa"
                    rules="required"
                >
                  <v-select
                      id="etapa"
                      v-model="etapa"
                      :options="etapas"
                      placeholder="Seleccionar etapa..."
                      @input="asignarCampos"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group
                  label="Campo"
                  label-for="campo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Campo"
                    vid="campo"
                    rules="required"
                >
                  <v-select
                      id="campo"
                      v-model="campo"
                      :options="campos"
                      placeholder="Seleccionar campo..."
                      @input="asignarTurnos"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group
                  label="Turno"
                  label-for="turno"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Turno"
                    vid="turno"
                    rules="required"
                >
                  <v-select
                      id="turno"
                      v-model="turno"
                      :options="turnos"
                      placeholder="Seleccionar turno..."
                      @input="asignarCodigos"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group label="Estado" label-for="estado_lote">
                <validation-provider #default="{ errors }" name="Estado" vid="estado_lote" rules="required">
                  <v-select
                    id="estado_lote"
                    v-model="estado_lote"
                    :options="estados_lotes"
                    :reduce="estados => estados.value"
                    label="text"
                    key="value"
                    placeholder="Seleccionar estado..."
                    @input="filtrarPorEstadoUno"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group
                  label="Codigo Homologado"
                  label-for="codigo_h"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Codigo Homologado"
                    vid="codigo_h"
                    rules="required"
                >
                  <v-select
                      id="codigo_h"
                      v-model="codigo_h"
                      :options="codigos_h"
                      :reduce="codigos_h => codigos_h.data"
                      label="codigo_h"
                      key="data"
                      placeholder="Seleccionar codigo..."
                      @input="seleccionarCodigoN"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

          </b-row>
          <b-row>
            <b-col lg="3">
              <b-form-group
                  label="Variedad"
                  label-for="variedad"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Variedad"
                    vid="variedad"
                    rules="required"
                >
                  <b-form-input
                      id="variedad"
                      v-model="variedad"
                      :state="errors.length > 0 ? false:null"
                      name="variedad"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="Lote"
                  label-for="lote"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Lote"
                    vid="lote"
                    rules="required"
                >
                  <b-form-input
                      id="lote"
                      v-model="lote"
                      :state="errors.length > 0 ? false:null"
                      name="lote"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="Valvula"
                  label-for="valvula"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Valvula"
                    vid="valvula"
                    rules="required"
                >
                  <b-form-input
                      id="valvula"
                      v-model="valvula"
                      :state="errors.length > 0 ? false:null"
                      name="valvula"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="Área"
                  label-for="area"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Área"
                    vid="area"
                    rules="required"
                >
                  <b-form-input
                      id="area"
                      v-model="area"
                      :state="errors.length > 0 ? false:null"
                      name="area"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <b-form-group
                  label="Código"
                  label-for="codigo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Código"
                    vid="codigo"
                    rules="required"
                >
                  <b-input-group>
                    <b-form-input
                        id="codigo"
                        v-model="codigo"
                        :state="errors.length > 0 ? false:null"
                        name="codigo"
                    />
                    <b-input-group-append>
                      <b-button
                          variant="primary"
                          class="btn-icon"
                          block
                          @click="buscarProducto"
                          :disabled="!codigo"
                      >
                        &emsp13;
                        <feather-icon v-if="loadingBP" icon="RotateCwIcon" class="spinner" />
                        <feather-icon v-else icon="SearchIcon" />
                        &emsp13;
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group
                  label="Producto"
                  label-for="producto"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Producto"
                    vid="producto"
                    rules="required"
                >
                  <b-form-input
                      id="producto"
                      v-model="producto"
                      :state="errors.length > 0 ? false:null"
                      name="producto"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="Grupo"
                  label-for="grupo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Grupo"
                    vid="grupo"
                    rules="required"
                >
                  <b-form-input
                      id="grupo"
                      v-model="grupo"
                      :state="errors.length > 0 ? false:null"
                      name="grupo"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="Und. Medida"
                  label-for="uni_med"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Und. Medida"
                    vid="uni_med"
                    rules="required"
                >
                  <b-form-input
                      id="uni_med"
                      v-model="uni_med"
                      :state="errors.length > 0 ? false:null"
                      name="uni_med"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <b-form-group
                  :label="`${uni_med ? uni_med + '/' : ''}Ha/Día`"
                  label-for="kg_ha_dia"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Kg/Ha/Día"
                    vid="kg_ha_dia"
                    rules="required|double|max:7"
                >
                  <b-form-input
                      id="kg_ha_dia"
                      v-model="kg_ha_dia"
                      :state="errors.length > 0 ? false:null"
                      name="kg_ha_dia"
                      @input="calcularMaxDia"
                      :disabled="!area"
                      placeholder="0.0"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group
                  :label="`Total Max. Día ${uni_med ? '(' + uni_med + ')' : ''}`"
                  label-for="total_max_dia"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Total Max. Día"
                    vid="total_max_dia"
                    rules="required"
                >
                  <b-form-input
                      id="total_max_dia"
                      v-model="total_max_dia"
                      :state="errors.length > 0 ? false:null"
                      name="total_max_dia"
                      disabled
                      placeholder="0.0"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group
                  label="Días"
                  label-for="dias"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Días"
                    vid="dias"
                    rules="required|integer|between:1,7"
                >
                  <b-form-input
                      id="dias"
                      v-model="dias"
                      :state="errors.length > 0 ? false:null"
                      name="dias"
                      @input="asignarMaxDiaSemana"
                      :disabled="!total_max_dia"
                      placeholder="0"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group
                  label="Lunes"
                  label-for="lunes"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Lunes"
                    vid="lunes"
                    rules="required|double|max:8"
                >
                  <b-form-input
                      id="lunes"
                      v-model="lunes"
                      :state="errors.length > 0 ? false:null"
                      name="lunes"
                      @input="comporbarExcedente"
                      placeholder="0.0"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group
                  label="Martes"
                  label-for="martes"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Martes"
                    vid="martes"
                    rules="required|double|max:8"
                >
                  <b-form-input
                      id="martes"
                      v-model="martes"
                      :state="errors.length > 0 ? false:null"
                      name="martes"
                      @input="comporbarExcedente"
                      placeholder="0.0"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group
                  label="Miércoles"
                  label-for="miercoles"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Miércoles"
                    vid="miercoles"
                    rules="required|double|max:8"
                >
                  <b-form-input
                      id="miercoles"
                      v-model="miercoles"
                      :state="errors.length > 0 ? false:null"
                      name="miercoles"
                      @input="comporbarExcedente"
                      placeholder="0.0"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group
                  label="Jueves"
                  label-for="jueves"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Jueves"
                    vid="jueves"
                    rules="required|double|max:8"
                >
                  <b-form-input
                      id="jueves"
                      v-model="jueves"
                      :state="errors.length > 0 ? false:null"
                      name="jueves"
                      @input="comporbarExcedente"
                      placeholder="0.0"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group
                  label="Viernes"
                  label-for="viernes"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Viernes"
                    vid="viernes"
                    rules="required|double|max:8"
                >
                  <b-form-input
                      id="viernes"
                      v-model="viernes"
                      :state="errors.length > 0 ? false:null"
                      name="viernes"
                      @input="comporbarExcedente"
                      placeholder="0.0"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group
                  label="Sábado"
                  label-for="sabado"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Sábado"
                    vid="sabado"
                    rules="required|double|max:8"
                >
                  <b-form-input
                      id="sabado"
                      v-model="sabado"
                      :state="errors.length > 0 ? false:null"
                      name="sabado"
                      @input="comporbarExcedente"
                      placeholder="0.0"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group
                  label="Domingo"
                  label-for="domingo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Domingo"
                    vid="domingo"
                    rules="required|double|max:8"
                >
                  <b-form-input
                      id="domingo"
                      v-model="domingo"
                      :state="errors.length > 0 ? false:null"
                      name="domingo"
                      @input="comporbarExcedente"
                      placeholder="0.0"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!--
            <b-col lg="2">
              <b-form-group
                  label="Indicador"
                  label-for="indicador"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Indicador"
                    vid="indicador"
                    rules="required"
                >
                  <b-form-input
                      id="indicador"
                      v-model="indicador"
                      :state="errors.length > 0 ? false:null"
                      name="indicador"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            -->

          </b-row>
          <b-row>
            <b-col lg="12">
              <b-alert
                  variant="danger"
                  class="mb-0"
                  :show="mostrarAlert"
              >
                <div class="alert-body">
                  <feather-icon
                      icon="InfoIcon"
                      class="mr-50"
                  />
                  La suma total de días, excede o es menor que el total máximo permitido.
                </div>
              </b-alert>
            </b-col>
            <b-col lg="12">
              <b-alert
                  variant="danger"
                  class="mb-0"
                  :show="mostrarAlert2"
              >
                <div class="alert-body">
                  <feather-icon
                      icon="InfoIcon"
                      class="mr-50"
                  />
                  Se han colocado valores en más días de los ingresados.
                </div>
              </b-alert>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal
        id="modal-editar"
        ref="modal-editar"
        v-model="estadoModalEditar"
        title="Editar Registro"
        ok-title="Editar"
        cancel-title="Cancelar"
        cancel-variant="outline-secondary"
        :size="loadingEDI ? 'md':'xl'"
        :cancel-disabled="loadingEDI"
        :ok-disabled="loadingEDI"
        centered
        no-close-on-esc
        no-close-on-backdrop
        @show=""
        @hidden="resetModal"
        @ok="validarRegistroEditar"
    >
      <div v-if="loading2"  align="center">
        <p>Editando ... </p>
        <b-spinner label="Loading..." variant="primary"/>
      </div>
      <validation-observer v-else ref="formularioEditarFertilizacion" #default="{invalid}">
        <b-form autocomplete="off" @submit.prevent="editarRegistro">
          <b-row>
            <b-col lg="2">
              <b-form-group
                  label="Semana"
                  label-for="semana_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Semana"
                    vid="semana_e"
                    rules="required|integer|between:1,52"
                >
                  <b-form-input
                      id="semana_e"
                      v-model="semana"
                      :state="errors.length > 0 ? false:null"
                      name="semana"
                      @input="asignarInicioFinSemana"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group
                  label="Empresa"
                  label-for="empresa_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Empresa"
                    vid="empresa_e"
                    rules="required"
                >
                  <v-select
                      id="empresa_e"
                      v-model="empresa"
                      :options="empresas"
                      placeholder="Seleccionar empresa..."
                      @input="asignarCultivos"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group
                  label="Cultivo"
                  label-for="cultivo_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Cultivo"
                    vid="cultivo_e"
                    rules="required"
                >
                  <v-select
                      id="cultivo_e"
                      v-model="cultivo"
                      :options="cultivos"
                      placeholder="Seleccionar cultivo..."
                      @input="asignarFundos"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="Fundo"
                  label-for="fundo_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Fundo"
                    vid="fundo_e"
                    rules="required"
                >
                  <v-select
                      id="fundo_e"
                      v-model="fundo"
                      :options="fundos"
                      placeholder="Seleccionar fundo..."
                      @input="asignarEtapas"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group
                  label="Etapa Fenológica"
                  label-for="etapa_fen"
              >
                <validation-provider
                    #default="{ errors }"
                    name="etapa_fen"
                    vid="etapa_fen"
                    rules="required"
                >
                  <v-select
                      id="etapa_fen"
                      v-model="eta_fen_seleccionada"
                      :options="etapas_fenológicas"
                      placeholder="Seleccionar etapa fenológica..."
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group
                  label="Concentracion"
                  label-for="por_concentracion"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Concentracion"
                    vid="por_concentracion"
                    rules="required|double|max:8"
                >
                  <b-form-input
                      id="por_concentracion"
                      v-model="por_concentracion"
                      :state="errors.length > 0 ? false:null"
                      name="por_concentracion"
                      placeholder="0.0"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group
                  label="Etapa"
                  label-for="etapa_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Etapa"
                    vid="etapa_e"
                    rules="required"
                >
                  <v-select
                      id="etapa_e"
                      v-model="etapa"
                      :options="etapas"
                      placeholder="Seleccionar etapa..."
                      @input="asignarCampos"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group
                  label="Campo"
                  label-for="campo_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Campo"
                    vid="campo_e"
                    rules="required"
                >
                  <v-select
                      id="campo_e"
                      v-model="campo"
                      :options="campos"
                      placeholder="Seleccionar campo..."
                      @input="asignarTurnos"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group
                  label="Turno"
                  label-for="turno_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Turno"
                    vid="turno_e"
                    rules="required"
                >
                  <v-select
                      id="turno_e"
                      v-model="turno"
                      :options="turnos"
                      placeholder="Seleccionar turno..."
                      @input="asignarCodigos"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
<!--

            <b-col lg="3">
              <b-form-group
                  label="Turno"
                  label-for="turno_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Turno"
                    vid="turno_e"
                    rules="required"
                >
                  <v-select
                      id="turno_e"
                      v-model="turno"
                      :options="turnos"
                      :reduce="turnos => turnos.data"
                      label="turno"
                      key="data"
                      placeholder="Seleccionar turno..."
                      @input="seleccionarCodigoN"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
-->
            <b-col lg="3">
              <b-form-group label="Estado" label-for="estado_lote_e">
                <validation-provider #default="{ errors }" name="Estado" vid="estado_lote_e" rules="required">
                  <v-select
                    id="estado_lote_e"
                    v-model="estado_lote"
                    :options="estados_lotes"
                    :reduce="estados => estados.value"
                    label="text"
                    key="value"
                    placeholder="Seleccionar estado..."
                    @input="filtrarPorEstadoUno"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group
                  label="Codigo Homologado"
                  label-for="codigo_h_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Codigo Homologado"
                    vid="codigo_h_e"
                    rules="required"
                >
                  <v-select
                      id="codigo_h_e"
                      v-model="codigo_h"
                      :options="codigos_h"
                      :reduce="codigos_h => codigos_h.data"
                      label="codigo_h"
                      key="data"
                      placeholder="Seleccionar codigo..."
                      @input="seleccionarCodigoN"
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group
                  label="Variedad"
                  label-for="variedad_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Variedad"
                    vid="variedad_e"
                    rules="required"
                >
                  <b-form-input
                      id="variedad_e"
                      v-model="variedad"
                      :state="errors.length > 0 ? false:null"
                      name="variedad"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="Lote"
                  label-for="lote_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Lote"
                    vid="lote_e"
                    rules="required"
                >
                  <b-form-input
                      id="lote_e"
                      v-model="lote"
                      :state="errors.length > 0 ? false:null"
                      name="lote"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="Valvula"
                  label-for="valvula_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Valvula"
                    vid="valvula_e"
                    rules="required"
                >
                  <b-form-input
                      id="valvula_e"
                      v-model="valvula"
                      :state="errors.length > 0 ? false:null"
                      name="valvula"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="Área"
                  label-for="area_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Área"
                    vid="area_e"
                    rules="required"
                >
                  <b-form-input
                      id="area_e"
                      v-model="area"
                      :state="errors.length > 0 ? false:null"
                      name="area"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  label="Código"
                  label-for="codigo_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Código"
                    vid="codigo_e"
                    rules="required"
                >
                  <b-input-group>
                    <b-form-input
                        id="codigo_e"
                        v-model="codigo"
                        :state="errors.length > 0 ? false:null"
                        name="codigo"
                    />
                    <b-input-group-append>
                      <b-button
                          variant="primary"
                          class="btn-icon"
                          block
                          @click="buscarProducto"
                          :disabled="!codigo"
                      >
                        &emsp13;
                        <feather-icon v-if="loadingBP" icon="RotateCwIcon" class="spinner" />
                        <feather-icon v-else icon="SearchIcon" />
                        &emsp13;
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group
                  label="Producto"
                  label-for="producto_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Producto"
                    vid="producto_e"
                    rules="required"
                >
                  <b-form-input
                      id="producto_e"
                      v-model="producto"
                      :state="errors.length > 0 ? false:null"
                      name="producto"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="Grupo"
                  label-for="grupo_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Grupo"
                    vid="grupo_e"
                    rules="required"
                >
                  <b-form-input
                      id="grupo_e"
                      v-model="grupo"
                      :state="errors.length > 0 ? false:null"
                      name="grupo"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="Und. Medida"
                  label-for="uni_med_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Und. Medida"
                    vid="uni_med"
                    rules="required"
                >
                  <b-form-input
                      id="uni_med_e"
                      v-model="uni_med"
                      :state="errors.length > 0 ? false:null"
                      name="uni_med"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group
                  :label="`${uni_med ? uni_med + '/' : ''}Ha/Día`"
                  label-for="kg_ha_dia_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Kg/Ha/Día"
                    vid="kg_ha_dia_e"
                    rules="required|double|max:7"
                >
                  <b-form-input
                      id="kg_ha_dia_e"
                      v-model="kg_ha_dia"
                      :state="errors.length > 0 ? false:null"
                      name="kg_ha_dia"
                      @input="calcularMaxDia"
                      :disabled="!area"
                      placeholder="0.0"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group
                  :label="`Total Max. Día ${uni_med ? '(' + uni_med + ')' : ''}`"
                  label-for="total_max_dia_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Total Max. Día"
                    vid="total_max_dia_e"
                    rules="required"
                >
                  <b-form-input
                      id="total_max_dia_e"
                      v-model="total_max_dia"
                      :state="errors.length > 0 ? false:null"
                      name="total_max_dia"
                      disabled
                      placeholder="0.0"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group
                  label="Días"
                  label-for="dias_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Días"
                    vid="dias_e"
                    rules="required|integer|between:1,7"
                >
                  <b-form-input
                      id="dias_e"
                      v-model="dias"
                      :state="errors.length > 0 ? false:null"
                      name="dias"
                      @input="asignarMaxDiaSemana"
                      :disabled="!total_max_dia"
                      placeholder="0"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group
                  label="Lunes"
                  label-for="lunes_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Lunes"
                    vid="lunes_e"
                    rules="required|double|max:8"
                >
                  <b-form-input
                      id="lunes_e"
                      v-model="lunes"
                      :state="errors.length > 0 ? false:null"
                      name="lunes"
                      @input="comporbarExcedente"
                      placeholder="0.0"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group
                  label="Martes"
                  label-for="martes_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Martes"
                    vid="martes_e"
                    rules="required|double|max:8"
                >
                  <b-form-input
                      id="martes_e"
                      v-model="martes"
                      :state="errors.length > 0 ? false:null"
                      name="martes"
                      @input="comporbarExcedente"
                      placeholder="0.0"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group
                  label="Miércoles"
                  label-for="miercoles_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Miércoles"
                    vid="miercoles_e"
                    rules="required|double|max:8"
                >
                  <b-form-input
                      id="miercoles_e"
                      v-model="miercoles"
                      :state="errors.length > 0 ? false:null"
                      name="miercoles"
                      @input="comporbarExcedente"
                      placeholder="0.0"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group
                  label="Jueves"
                  label-for="jueves_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Jueves"
                    vid="jueves_e"
                    rules="required|double|max:8"
                >
                  <b-form-input
                      id="jueves_e"
                      v-model="jueves"
                      :state="errors.length > 0 ? false:null"
                      name="jueves"
                      @input="comporbarExcedente"
                      placeholder="0.0"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group
                  label="Viernes"
                  label-for="viernes_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Viernes"
                    vid="viernes_e"
                    rules="required|double|max:8"
                >
                  <b-form-input
                      id="viernes_e"
                      v-model="viernes"
                      :state="errors.length > 0 ? false:null"
                      name="viernes"
                      @input="comporbarExcedente"
                      placeholder="0.0"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group
                  label="Sábado"
                  label-for="sabado_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Sábado"
                    vid="sabado_e"
                    rules="required|double|max:8"
                >
                  <b-form-input
                      id="sabado_e"
                      v-model="sabado"
                      :state="errors.length > 0 ? false:null"
                      name="sabado"
                      @input="comporbarExcedente"
                      placeholder="0.0"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group
                  label="Domingo"
                  label-for="domingo_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Domingo"
                    vid="domingo_e"
                    rules="required|double|max:8"
                >
                  <b-form-input
                      id="domingo_e"
                      v-model="domingo"
                      :state="errors.length > 0 ? false:null"
                      name="domingo"
                      @input="comporbarExcedente"
                      placeholder="0.0"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!--
            <b-col lg="2">
              <b-form-group
                  label="Indicador"
                  label-for="indicador"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Indicador"
                    vid="indicador"
                    rules="required"
                >
                  <b-form-input
                      id="indicador"
                      v-model="indicador"
                      :state="errors.length > 0 ? false:null"
                      name="indicador"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            -->

          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal
        id="modal-importar"
        ref="modal-importar"
        v-model="estadoModalImportar"
        title="Importar Datos Masivos"
        ok-title="Importar"
        cancel-title="Cancelar"
        cancel-variant="outline-secondary"
        size="md"
        :cancel-disabled="loadingIMP"
        :ok-disabled="loadingIMP||!archivo_excel"
        centered
        no-close-on-esc
        no-close-on-backdrop
        @show=""
        @hidden=""
        @ok="importarOk"
    >
      <div v-if="loadingIMP"  align="center">
        <p>Importando datos ... </p>
        <b-spinner label="Loading..." variant="primary"/>
      </div>
      <validation-observer v-else ref="formularioImportar" #default="{invalid}">
        <b-form autocomplete="off" @submit.prevent="enviarFile">
          <b-row>
            <!--
            <b-col lg="12">
              <b-form-group
                  label="Cultivo"
                  label-for="cultivo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Cultivo"
                    vid="cultivo"
                    rules="required"
                >
                  <v-select
                      id="cultivo"
                      v-model="cultivoIMP"
                      :options="cultivosIMP"
                      placeholder="Seleccionar cultivo..."
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            -->
            <b-col lg="12">
              <b-form-group
                  label="Archivo"
                  label-for="archivo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Archivo"
                    vid="archivo"
                    rules="required"
                >
                  <b-form-file
                      id="archivo"
                      accept=".xlsx"
                      placeholder="Seleccionar Archivo Excel (.xlsx)"
                      v-model="archivo_excel"
                      ref="fileinput"
                  >
                    <template
                        slot="file-name"
                        slot-scope="{ names }"
                    >
                      <b-badge variant="primary">
                        {{ names[0] }}
                      </b-badge>
                    </template>
                  </b-form-file>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal
        id="modal-respuesta"
        ref="modal-respuesta"
        v-model="estadoModalRespuesta"
        title="Respuesta"
        ok-title="Aceptar"
        ok-only
        size="md"
        no-close-on-esc
        no-close-on-backdrop
        @show=""
        @hidden=""
        scrollable
    >
      <b-row>
        <b-col lg="12">
          <span>Se realizaron la creación de {{ respuestaRegistrosTotal }} registros satisfactoriamente.</span><br><br>
          <span>Se encontraron {{ respuestaErrores.length }} registros con errores:</span><br><br>
          <div
              v-for="error in respuestaErrores"
              :key="error.contador2"
          >
            <div class="mb-1">
              <span>Codigo homologado: {{ error.cod_homologado }}</span><br>
              <span>Error: {{ error.error }}.</span>
              <span>Fila: {{ error.id }}.</span>
            </div>
          </div>


        </b-col>
      </b-row>
    </b-modal>

    <b-modal
        id="modal-select2"
        v-model="modalEditarEstadoShow"
        no-close-on-esc
        no-close-on-backdrop
        cancel-variant="secondary"
        ok-title="Actualizar"
        :ok-disabled="!estado_aprobar"
        cancel-title="Cancelar"
        centered
        title="Autorizar registro"
        @ok="aprobar"
    >
      <b-form>
        <b-form-group
            label="Estado"
            label-for="estado_editar"
        >
          <v-select
              id="estado_editar"
              v-model="estado_aprobar"
              :options="estados"
              :reduce="estados => estados.value"
              label="text"
              key="value"
              placeholder="Seleccionar estado..."
          />
        </b-form-group>
        <!--
        <b-form-group
            label="Comentario"
            label-for="comentario"
        >
          <b-form-textarea
              v-model="comentario"
              id="comentario"
              placeholder="Comentario"
              rows="3"
          />
        </b-form-group>
        -->
      </b-form>
    </b-modal>
  </div>
</template>

<script>

import axiosIns from '../../libs/axios'
import vSelect from 'vue-select'
import {
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BModal,
  BPagination,
  BSpinner,
  BTable,
  BRow,
  BCol,
  BDropdownDivider,
  BFormFile,
  VBModal,
  BTooltip,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend, BFormTextarea, BLink, BButtonGroup,
  BAlert, VBTooltip,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required, double, max, between, integer } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  components: {
    BCard,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BButton,
    BFormInput,
    BModal,
    VBModal,
    BForm,
    BCol,
    BRow,
    BDropdownDivider,
    BFormFile,
    BTooltip,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormTextarea,
    BLink,
    BButtonGroup,
    BAlert,

    vSelect,

    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },
  data: () => ({
    id_user: JSON.parse(localStorage.getItem('userData')).id,
    inicioSemana: null,
    finSemana:null,
    semana: null,
    cultivo: null,
    cultivoIMP: null,
    empresa: null,
    fundo: null,
    etapa: null,
    campo: null,
    turno: null,
    codigo_h: null,
    variedad: null,
    lote: null,
    valvula: null,
    area: null,
    codigo: null,
    producto: null,
    grupo: null,
    uni_med: null,

    title_sem: null,

    empresaFiltro: null,
    empresasFiltro: [],
    semanaFiltro: null,
    semanasFiltro: [],
    cultivoFiltro: null,
    cultivosFiltro: [],

    dias: null,
    kg_ha_dia: null,
    total_max_dia: null,

    lunes: null,
    martes: null,
    miercoles: null,
    jueves: null,
    viernes: null,
    sabado: null,
    domingo: null,

    indicador: null,

    submittedNames: [],
    loading: false,
    loading2: false,
    loadingBP: false,
    loadingDE: false,
    loadingIMP: false,
    loadingEDI: false,

    loadingSAC: false,
    loadingSSC: false,
    loadingSSM: false,
    loadingSAM: false,
    loadingSAD: false,
    loadingSSD: false,

    estadoModalEditar: false,
    estadoModalImportar: false,
    estadoModalRespuesta: false,
    modal_registro_o: false,

    modalEditarEstadoShow: false,
    items: [],
    items_completo: [],
    perPage: 5,
    pageOptions: [5, 10, 15, 30],
    totalRows: 0,
    currentPage: 1,
    sortBy: 'id',
    sortDesc: true,
    sortDirection: 'desc',
    filter: null,
    filter_sig: null,
    filterOn: ['semana'],
    fields: [
      {
        key: 'acciones',
        label: '# ',
        class: 'text-nowrap text-center',
        stickyColumn: true,
      },
      {
        key: 'estado',
        label: 'estado',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'semana',
        label: 'semana',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'cultivo',
        label: 'cultivo',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'empresa',
        label: 'empresa',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      // {
      //   key: 'fundo',
      //   label: 'fundo',
      //   class: 'text-nowrap text-center',
      //   sortable: true,
      // },

      /*
      {
        key: 'etapa',
        label: 'etapa',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'campo',
        label: 'campo',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'turno',
        label: 'turno',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'variedad',
        label: 'variedad',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'lote',
        label: 'lote',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'valvula',
        label: 'válvula',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'area',
        label: 'área',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'cod_producto',
        label: 'cod',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'producto',
        label: 'producto',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'grupo_producto',
        label: 'grupo producto',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'und_medida',
        label: 'und. medida',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'dias',
        label: 'dias',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'kg_ha_dia',
        label: 'kg/ha/dia',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'total_max_dia',
        label: 'total_max_dia',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'lun',
        label: 'lun',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'mar',
        label: 'mar',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'mie',
        label: 'mie',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'jue',
        label: 'jue',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'vie',
        label: 'vie',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'sab',
        label: 'sab',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'dom',
        label: 'dom',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      */

      {
        key: 'version',
        label: 'versión',
        class: 'text-nowrap text-center',
        sortable: true,
      },

      {
        key: 'resumen',
        label: 'Resumen',
        class: 'text-nowrap text-center',
        sortable: true,
      },
        /*
      {
        key: 'con_usuario.username',
        label: 'Usuario',
        class: 'text-nowrap text-center',
        sortable: true,
      },
        */
      {
        key: 'created',
        label: 'Fecha - Hora',
        class: 'text-nowrap text-center',
        sortable: true,
      },
    ],
    fields_detalle_SemAct: [
      {
        key: 'accionesdos',
        label: '# ',
        class: 'text-nowrap text-center',
      },
      {
        key: 'estado',
        label: 'estado',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'fundo',
        label: 'fundo',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'etapa_fen',
        label: 'ETATA FEN.',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'por_concentracion',
        label: '%CONCENTRACIÓN',
        label: '% CONCENTRACIÓN',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'etapa',
        label: 'etapa',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'campo',
        label: 'campo',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'turno',
        label: 'turno',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'variedad',
        label: 'variedad',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'lote',
        label: 'lote',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'valvula',
        label: 'válvula',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'area',
        label: 'área',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'cod_producto',
        label: 'cod',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'producto',
        label: 'producto',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'grupo_producto',
        label: 'grupo producto',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'und_medida',
        label: 'und. medida',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'dias',
        label: 'dias',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'kg_ha_dia',
        label: 'kg/ha/dia',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'total_max_dia',
        label: 'total_max_dia',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'lun',
        label: 'lun',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'mar',
        label: 'mar',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'mie',
        label: 'mie',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'jue',
        label: 'jue',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'vie',
        label: 'vie',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'sab',
        label: 'sab',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'dom',
        label: 'dom',
        class: 'text-nowrap text-center',
        sortable: true,
      },
        /*
      {
        key: 'created',
        label: 'Fecha - Hora',
        class: 'text-nowrap text-center',
        sortable: true,
      },
        */
    ],
    status: [
      {
        0: 'Pendiente',
        1: 'Revisado',
        2: 'Aprobado',
        3: 'Desaprobado',
        4: 'Eliminado',
        5: 'Conforme'
      },
      {
        0: 'light-info',
        1: 'light-warning',
        2: 'light-success',
        3: 'light-danger',
        4: 'light-dark',
        5: 'light-primary'
      }
    ],

    estados: [
      {value: '1', text: "Dar visto bueno"},
      /*
      {value: '1', text: "Observar"},
      {value: '3', text: "Desaprobar"}
       */
    ],

    estados_lotes: [
      { value: '0', text: "Activo" },
      { value: '1', text: "Agrupado" },
      { value: '2', text: "Pendiente" },
    ],
    id_editar: null,
    parametros_usuario: [],
    codigos_h_resp : [],
    estado_aprobar: null,
    estado_lote: null,
    archivo_excel: null,
    empresas: [],
    cultivos: [],
    cultivosIMP: ['ARANDANO', 'ESPÁRRAGO', 'PALTA', 'UVA'],
    fundos: [],
    etapas: [],
    campos: [],
    turnos: [],
    codigos_h: [],
    parametros: [],


    dataEmpresa: [],
    dataLotesValvulas: [],
    notDuplicados: [],
    dataCompleta: [],
    etapas_fenológicas : ['PRODUCTIVA','RENOVACIÓN'],
    eta_fen_seleccionada : null,
    por_concentracion : null,
    spd: [],
    dia: null,
    hora: null,

    comentario: null,

    semana_sig: null,
    inicioSemana_sig: null,
    finSemana_sig: null,

    mostrarSemAct: false,
    mostrarSemSgte: false,
    items_sem_act: [],
    items_sem_sgte: [],
    responsable: [],

    dataAutorizar:null,

    semanaActual: true,
    semanaEnviar: null,

    mostrarAlert: false,
    mostrarAlert2: false,

    respuestaRegistrosTotal: 0,
    respuestaErrores: [],

    anio:null,

    // validation rules
    required,
    double,
    max,
    between,
    integer,
  }),
  computed: {},
  async mounted() {
    await this.buscarResponsable();
    await this.dataInicial();
    await this.traerDataEmpresa();
    // await this.traerDataLotesValvulas();
    await this.traerFertilizaciones();
    localize("es");
  },
  methods: {
    dataInicial(){
      const spd = this.numeroDeSemana(new Date())
      this.semana = spd.n_semana.toString().padStart(2, '0')
      this.inicioSemana = spd.inicio.toLocaleString('pe-PE', {
       month: 'long',
       day: '2-digit',
       year: 'numeric',
       localeMatcher: 'best fit',
       timeZone: 'America/Lima'
      })
      this.finSemana = spd.fin.toLocaleString('pe-PE', {
       month: 'long',
       day: '2-digit',
       year: 'numeric',
       localeMatcher: 'best fit',
       timeZone: 'America/Lima'
      })

      this.semana_sig = spd.n_semana === 52 ? '01' : (spd.n_semana + 1).toString().padStart(2, '0')
      // this.semana_sig = spd.n_semana + 1
      spd.inicio.setDate(spd.inicio.getDate() + 7)
      spd.fin.setDate(spd.fin.getDate() + 7)

      this.inicioSemana_sig = spd.inicio.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })
      this.finSemana_sig = spd.fin.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })

      this.anio = this.finSemana_sig.substring(this.finSemana_sig.length - 4)

      // Asignar valores manuales y estaticos para fechas, si es necesario
      // this.semana = "46";
      // this.semana_sig = "47";
      // this.inicioSemana = "11 de noviembre de 2024";
      // this.finSemana = "17 de noviembre de 2024";
      // this.inicioSemana_sig = "18 de noviembre de 2024";
      // this.finSemana_sig = "24 de noviembre de 2024";
      // this.anio = "2024";

      this.filter = this.semana;
      this.filter_sig = this.semana_sig;

    },

    traerFertilizaciones(){
      const yo = this
      yo.loading = true

      const config = {
        method: 'get',
        url: '/pagricolas/fertilizacion/'
      }

      axiosIns(config)
        .then(function (response) {
          if(response.status === 200){

            yo.items_completo = response.data;
            yo.items = response.data;
            yo.spd = response.data;
            yo.totalRows = yo.items.length
            yo.empresasFiltro = []
            yo.semanasFiltro = []
            yo.cultivosFiltro = []
            yo.notDuplicados = []
            const arr = []
            let val = ''

            let sumL = 0
            let sumKG = 0
            let indice = 0
            let c = 0

            let ultimasVersiones = {};
            yo.items.forEach(item => {
                let cultivo = item.cultivo;
                let empresa = item.empresa;
                let semana = item.semana;
                let version = parseInt(item.version, 10); // Convertir la versión a número
                let clave = cultivo + '-' + empresa + '-' + semana;
                if (ultimasVersiones[clave]) {
                    if (version > parseInt(ultimasVersiones[clave].version, 10)) { // Comparar versiones como números
                        ultimasVersiones[clave] = item;
                    }
                } else {
                    ultimasVersiones[clave] = item;
                }
            });
            let ultimasVersionesArray = Object.values(ultimasVersiones);
            yo.items = ultimasVersionesArray

            for (let valor of yo.items){
              yo.empresasFiltro.push(valor.empresa)
              yo.semanasFiltro.push(valor.semana)
              yo.cultivosFiltro.push(valor.cultivo)
              yo.notDuplicados.push(valor.semana+valor.cultivo+valor.empresa+valor.fundo)

              if(val!==valor.semana+valor.cultivo+valor.empresa){
                arr.push(valor)
                if(indice!==0){
                  arr[indice-1].resumen = sumL.toFixed(3) + ' L - ' + sumKG.toFixed(3) + ' KG'
                }
                sumL = 0
                sumKG = 0
                indice ++
              }

              if (valor.und_medida === 'L' ){
                sumL = sumL + (parseFloat(valor.lun) + parseFloat(valor.mar) + parseFloat(valor.mie) + parseFloat(valor.jue) + parseFloat(valor.vie) + parseFloat(valor.sab) + parseFloat(valor.dom))
              }

              if (valor.und_medida === 'KG' ){
                sumKG = sumKG + (parseFloat(valor.lun) + parseFloat(valor.mar) + parseFloat(valor.mie) + parseFloat(valor.jue) + parseFloat(valor.vie) + parseFloat(valor.sab) + parseFloat(valor.dom))
              }

              val = valor.semana+valor.cultivo+valor.empresa
              c++

              if(c===yo.items.length){
                arr[indice-1].resumen = sumL.toFixed(3) + ' L / ' + sumKG.toFixed(3) + ' KG'
              }
            }

            yo.empresasFiltro = [... new Set(yo.empresasFiltro)];
            yo.semanasFiltro = [... new Set(yo.semanasFiltro)];
            yo.cultivosFiltro = [... new Set(yo.cultivosFiltro)];
            yo.notDuplicados = [... new Set(yo.notDuplicados)];

            yo.items = arr

            //Valido por Empresa
            if(yo.responsable[0].empresa !== 'TODOS'){ // Se asume que es AGV o ARV, nunca ambos. Y si fuera el caso sería 'TODOS'
                yo.items = yo.items.filter(
                  invoice => invoice.empresa === yo.responsable[0].empresa
                )
            }

            //Valido por Cultivo
            if(yo.responsable[0].cultivo !== 'TODOS'){
              //Filtro utilizando el include asumiendo que en algunos casos solo sera 01 cultivo y en otros seran varios.
              yo.items = yo.items.filter(
                invoice => yo.responsable[0].cultivo.includes(invoice.cultivo)
              )

            }

            //Valido por Rol
            if(yo.responsable[0].rol === 'USUARIO'){
              yo.estados = [
                {value: '1', text: "Dar visto bueno"},
                {value: '4', text: "Eliminar"}
              ]
            }else if(yo.responsable[0].rol === 'JEFE DE RIEGO'){
              yo.estados = [
                {value: '2', text: "Aprobar"},
                {value: '3', text: "Desaprobar"}
              ]

              yo.items = yo.items.filter(
                invoice => invoice.estado !== '0' //Si es jefe de riego no debería ver pendientes, solo Revisados
              )
            }else if(yo.responsable[0].rol === 'JEFE DE RIEGO CORPORATIVO'){
              yo.estados = [
                {value: '5', text: "Dar Conformidad"}
              ]
              yo.items = yo.items.filter(
                invoice => invoice.estado === '2' || invoice.estado === '5' //Si es jefe corporativo solo debería ver Aprobados y Conformes
              )
            }else if(yo.responsable[0].rol === 'ADMINISTRADOR'){
              yo.estados = [
                {value: '1', text: "Dar visto bueno"},
                {value: '2', text: "Aprobar"},
                {value: '3', text: "Desaprobar"},
                {value: '4', text: "Eliminar"},
                {value: '5', text: "Dar Conformidad"}
              ]
            }



            //// ANTIGUA VALIDACION
            // if(yo.responsable[0].rol === 'JEFE DE RIEGO'){
            //   yo.estados = [
            //     {value: '2', text: "Aprobar"},
            //     {value: '3', text: "Desaprobar"}
            //   ]

            //   yo.items = yo.items.filter(
            //       invoice => invoice.empresa === yo.responsable[0].empresa && invoice.estado !== '0'
            //   )

            // }
            // else if(yo.responsable[0].rol === 'USUARIO'){
            //   if(yo.responsable[0].empresa === 'TODOS'){
            //     yo.items = yo.items.filter(
            //         invoice => invoice.cultivo === yo.responsable[0].cultivo
            //     )
            //   }else if(yo.responsable[0].cultivo === 'TODOS'){
            //     yo.items = yo.items.filter(
            //         invoice => invoice.empresa === yo.responsable[0].empresa
            //     )
            //   }else{
            //     yo.items = yo.items.filter(
            //         invoice => invoice.cultivo === yo.responsable[0].cultivo && invoice.empresa === yo.responsable[0].empresa
            //     )
            //   }

            //   yo.estados = [
            //     {value: '1', text: "Dar visto bueno"},
            //     {value: '4', text: "Eliminar"}
            //   ]
            // }
            // else if(yo.responsable[0].rol === 'JEFE'){
            //   if(yo.responsable[0].empresa === 'TODOS'){
            //     yo.items = yo.items.filter(
            //         invoice => invoice.cultivo === yo.responsable[0].cultivo
            //     )
            //   }else if(yo.responsable[0].cultivo === 'TODOS'){
            //     yo.items = yo.items.filter(
            //         invoice => invoice.empresa === yo.responsable[0].empresa
            //     )
            //   }else{
            //     yo.items = yo.items.filter(
            //         invoice => invoice.cultivo === yo.responsable[0].cultivo && invoice.empresa === yo.responsable[0].empresa
            //     )
            //   }

            //   yo.estados = [
            //     {value: '1', text: "Dar visto bueno"},
            //     {value: '4', text: "Eliminar"}
            //   ]
            // }
            // else{
            //   yo.estados = [
            //     {value: '1', text: "Dar visto bueno"},
            //     {value: '2', text: "Aprobar"},
            //     {value: '3', text: "Desaprobar"},
            //     {value: '4', text: "Eliminar"}
            //   ]
            // }

          }

        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function (){
          yo.loading = false
        })
    },

    validarRegistroEditar(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.editarRegistro()
    },

    editarRegistro(){
      const yo = this

      this.$refs.formularioEditarFertilizacion.validate().then(success => {
        if (success){
          yo.loadingEditar = true

          const data = JSON.stringify({
            'semana': yo.semanaActual ? yo.semana : yo.semana_sig,
            'cultivo': yo.cultivo,
            // 'etapa_fen': 'PRODUCTIVA',
            'etapa_fen': yo.eta_fen_seleccionada,
            'por_concentracion': yo.por_concentracion,
            'empresa': yo.empresa,
            'fundo': yo.fundo,
            'etapa': yo.etapa,
            'campo': yo.campo,
            'turno': yo.turno,
            'variedad': yo.variedad,
            'lote': yo.lote,
            'valvula': yo.valvula,
            'area': yo.area,
            'cod_producto': yo.codigo,
            'producto': yo.producto,
            'grupo_producto': yo.grupo,
            'subgrupo_producto': null,
            'und_medida': yo.uni_med,
            'dias': yo.dias,
            'kg_ha_dia': yo.kg_ha_dia,
            'total_max_dia': yo.total_max_dia,
            'lun': yo.lunes,
            'mar': yo.martes,
            'mie': yo.miercoles,
            'jue': yo.jueves,
            'vie': yo.viernes,
            'sab': yo.sabado,
            'dom': yo.domingo,
            'estado': '0',
            'estado_lote': yo.estado_lote,
            'con_usuario': yo.id_user,
          })

          const config = {
            method: 'put',
            url: 'pagricolas/fertilizacion/editar/'+yo.id_editar,
            headers: {
              'Content-Type': 'application/json'
            },
            data: data
          }


          axiosIns(config)
              .then(function (response) {
                if (response.status === 200){
                  yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se editó de manera correcta", 'success', 5000)
                }
              })
              .catch(function (error) {
                console.log(error);
                yo.mostrarNotificacion('Error en la edición', 'BellIcon', 'Error: \n '+error.toString(), 'danger', 5000)
              })
              .finally(function (){
                yo.mostrarSemAct=false
                yo.mostrarSemSgte=false
                yo.traerFertilizaciones()

                yo.$nextTick(() => {
                  yo.$refs['modal-editar'].toggle('#toggle-btn')
                })
                yo.loadingEditar = false
              })

        }
      })
    },

    traerDataEmpresa(){
      const yo = this
      yo.loadingDE = true

      const data = JSON.stringify
      (
        {
          'version_elegida': 'A-V01.1 ENE',
          'subversion_elegida': '001'
        }
      )

      const config = {
        method: 'post',
        url: '/pagricolas/lotes/obtenerSoloLotesValvulasDetallado/',
        // url: '/lotes/obtenerLotesValvulasDetallado/',
        data: data
      }

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              let data_resumida_agrupada = []
              data_resumida_agrupada = yo.armarResumen(response.data['data'], response.data['cod_unicos']) //La data que ya esta agrupada por Activos, Pendientes y Agrupados

              yo.dataEmpresa = data_resumida_agrupada

              // yo.dataEmpresa = response.data['data'] //Por el momento le estoy asignando de frente la detallada
              // yo.dataCompleta = response.data['data']

              for (let value of yo.dataEmpresa){
                yo.empresas.push(value.sociedad)
              }

              yo.empresas = [...new Set(yo.empresas)].sort()

            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){

          })

    },

    //Esta funcion toma todos los registros detallados y los agrupa en Activos, Pendientes y Agrupados
    armarResumen(total_lotes_valvulas,cod_homo_unicos){

      let resumen_lotes_valvulas = [] //Almacenara los datos que se mostraran primero
      let turnos_vacios_sinlotesval = []

      for(let c of cod_homo_unicos){
        // console.log(c)
        let resultadosFiltrados = []
        //Del total filtro solo los que cumplen con el cod_homologado
        resultadosFiltrados = total_lotes_valvulas.filter(function(item) {
          return item.cod_homologado === c;
        });

        if(resultadosFiltrados.length > 0){
          // Recorro lo filtrado para volverle a pasar un segundo filtros entre Activos, Pendientes y Agrupados
          let lista_activos = []
          let lista_pendientes = []
          let lista_agrupados = []
          let lista_final = [] //Almacen el resumen por grupo segun el cod_homologado

          for(let x of resultadosFiltrados){
            //Activos
            if(x['estado_uno'] == '0'){ // 0  es Activo
              lista_activos.push(x)
            }
            //Pendientes
            if(x['estado_dos'] == '0'){
              lista_pendientes.push(x)
            }
            //Agrupados
            if(x['estado_uno'] == '1'){
              lista_agrupados.push(x)
            }

            if(x['lote'] == null || x['lote'] == ''){
              turnos_vacios_sinlotesval.push(x)
            }
          }


          if(lista_activos.length > 0){
            // Ahora trabajo la lista_final_activos
            let lista_final_activos = []
            let acumulador_activos = {
              estado_uno: 0,
              lote: [],
              valvula: [],
              area_subtotal: 0,
              area_real: 0,
              diferencia: 0,
              estado_dos: 0,
              cod_homologado: '',
              estado_resumen:'',
              area_total: ''
            }

            // ----Recorrer lista_activos y acumular valores
            lista_activos.forEach(function(item) {
              acumulador_activos.lote += item.lote + ",";
              acumulador_activos.valvula += item.valvula + ",";
              acumulador_activos.area_subtotal += item.area_subtotal;
              acumulador_activos.area_real += item.area_real;
              acumulador_activos.diferencia += item.diferencia;
              acumulador_activos.cod_homologado = item.cod_homologado;
              acumulador_activos.cod_homologado_turno = item.cod_homologado_turno;
              acumulador_activos.estado_uno_texto = item.estado_uno_texto;
              acumulador_activos.estado_dos_texto = item.estado_dos_texto;
              acumulador_activos.sociedad = item.sociedad;
              acumulador_activos.cultivo = item.cultivo;
              acumulador_activos.fundo = item.fundo;
              acumulador_activos.etapa = item.etapa;
              acumulador_activos.campo = item.campo;
              acumulador_activos.turno = item.turno;
              acumulador_activos.variedad = item.variedad;
              acumulador_activos.estado_resumen = item.estado_uno_texto;
              // acumulador_activos.area_total = item.area_ha;
              acumulador_activos.area_ha = item.area_ha;
              // acumulador_activos.id = item.turno_id;
              acumulador_activos.id_turno = item.id_turno;
            })

            // ----Eliminar la última coma de las cadenas de lote y valvula
            acumulador_activos.lote = acumulador_activos.lote.slice(0, -1);
            acumulador_activos.valvula = acumulador_activos.valvula.slice(0, -1);

            // ----Agregar el acumulador a lista_final_activos
            lista_final_activos.push(acumulador_activos);
            resumen_lotes_valvulas.push(acumulador_activos)
          }

          if(lista_pendientes.length > 0){
            // Ahora trabajo la lista_final_pendientes
            let lista_final_pendientes = []
            let acumulador_pendientes = {
              estado_uno: 0,
              lote: [],
              valvula: [],
              area_subtotal: 0,
              area_real: 0,
              diferencia: 0,
              estado_dos: 0,
              cod_homologado: '',
              estado_resumen:'',
              area_total:'',
            }

            lista_pendientes.forEach(function(item) {
              acumulador_pendientes.lote += item.lote + ",";
              acumulador_pendientes.valvula += item.valvula + ",";
              acumulador_pendientes.area_subtotal += item.area_subtotal;
              // acumulador_pendientes.area_real += item.area_real;
              acumulador_pendientes.area_real += item.diferencia; //Cuando solo son pendientes el area_real debe ser la sumatoria de la diferencia
              acumulador_pendientes.diferencia += item.diferencia;
              acumulador_pendientes.cod_homologado = item.cod_homologado;
              acumulador_pendientes.cod_homologado_turno = item.cod_homologado_turno;
              acumulador_pendientes.estado_uno_texto = item.estado_uno_texto;
              acumulador_pendientes.estado_dos_texto = item.estado_dos_texto;
              acumulador_pendientes.sociedad = item.sociedad;
              acumulador_pendientes.cultivo = item.cultivo;
              acumulador_pendientes.fundo = item.fundo;
              acumulador_pendientes.etapa = item.etapa;
              acumulador_pendientes.campo = item.campo;
              acumulador_pendientes.turno = item.turno;
              acumulador_pendientes.variedad = item.variedad;
              acumulador_pendientes.estado_resumen = item.estado_dos_texto;
              // acumulador_pendientes.area_total = item.area_ha;
              acumulador_pendientes.area_ha = item.area_ha;
              // acumulador_pendientes.id = item.turno_id;
              acumulador_pendientes.id_turno = item.id_turno;
            })

            // ----Eliminar la última coma de las cadenas de lote y valvula
            acumulador_pendientes.lote = acumulador_pendientes.lote.slice(0, -1);
            acumulador_pendientes.valvula = acumulador_pendientes.valvula.slice(0, -1);

            // ----Agregar el acumulador a lista_final_activos
            lista_final_pendientes.push(acumulador_pendientes);

            for(let y of lista_final_pendientes){
              if(y['estado_dos'] == '0'){
                y['estado_uno_texto'] = 'PENDIENTE'
              }
            }
            resumen_lotes_valvulas.push(acumulador_pendientes)
          }

          for(let z of lista_agrupados){
            z['estado_resumen'] = 'AGRUPADO'
            z['area_total'] = z['area_ha']
            resumen_lotes_valvulas.push(z)
          }
        }

      }

      // resumen_lotes_valvulas = resumen_lotes_valvulas.concat(turnos_vacios_sinlotesval)
      return resumen_lotes_valvulas;

    },

    // traerDataEmpresa(){
    //   const yo = this
    //   yo.loadingDE = true

    //   const data = JSON.stringify
    //   (
    //     {
    //       'version_elegida': 'A-V01.1 ENE',
    //       'subversion_elegida': '001'
    //     }
    //   )

    //   const config = {
    //     method: 'post',
    //     url: '/lotes/obtenerSoloLotesValvulasDetallado/',
    //     data: data
    //   }

    //   axiosIns(config)
    //       .then(function (response) {
    //         if(response.status === 200){
    //           console.log(response.data['data'])
    //           yo.dataEmpresa = response.data['data']
    //           // yo.dataCompleta = response.data['data']

    //           for (let value of yo.dataEmpresa){
    //             yo.empresas.push(value.sociedad)
    //           }

    //           yo.empresas = [...new Set(yo.empresas)].sort()

    //         }
    //       })
    //       .catch(function (error) {
    //         console.log(error);
    //       })
    //       .finally(function (){
    //         yo.loadingDE = false
    //       })

    // },

    // traerDataEmpresa(){
    //   const yo = this
    //   yo.loadingDE = true

    //   const config = {
    //     method: 'get',
    //     url: '/lotes/'
    //   }

    //   axiosIns(config)
    //       .then(function (response) {
    //         if(response.status === 200){
    //           yo.dataEmpresa = response.data['data_filtrada']
    //           yo.dataCompleta = response.data['data']

    //           for (let value of yo.dataEmpresa){
    //             yo.empresas.push(value.sociedad)
    //           }

    //           yo.empresas = [...new Set(yo.empresas)].sort()

    //         }
    //       })
    //       .catch(function (error) {
    //         console.log(error);
    //       })
    //       .finally(function (){
    //         yo.loadingDE = false
    //       })

    // },

    traerDataLotesValvulas(){
      const yo = this
      yo.loadingDE = true

      const config = {
        method: 'get',
        url: '/pagricolas/lotes/'
      }

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.dataLotesValvulas = response.data
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){
            yo.loadingDE = false
          })

    },

    asignarCultivos(){
      const yo = this
      yo.cultivos = []
      yo.cultivo = null
      yo.fundos = []
      yo.fundo = null
      yo.etapas = []
      yo.etapa = null
      yo.campos = []
      yo.campo = null
      yo.turnos = []
      yo.codigos_h = []
      yo.codigo_h = null
      yo.turno = null
      yo.variedad = null
      yo.lote = null
      yo.valvula = null
      yo.area = null

      for(let value of yo.dataEmpresa){
        if(value.sociedad === yo.empresa){
          yo.cultivos.push(value.cultivo)
        }
      }

      yo.cultivos = yo.cultivos.filter(item => item !== null);
      yo.cultivos = [... new Set(yo.cultivos)]

    },

    asignarFundos(){
      const yo = this
      yo.fundos = []
      yo.fundo = null
      yo.etapas = []
      yo.etapa = null
      yo.campos = []
      yo.campo = null
      yo.turnos = []
      yo.turno = null
      yo.codigos_h = []
      yo.codigo_h = null
      yo.variedad = null
      yo.lote = null
      yo.valvula = null
      yo.area = null

      for(let value of yo.dataEmpresa){
        if(value.sociedad === yo.empresa && value.cultivo === yo.cultivo){
          yo.fundos.push(value.fundo)
        }
      }

      yo.fundos = [... new Set(yo.fundos)]

    },

    asignarEtapas(){
      const yo = this

      yo.etapas = []
      yo.etapa = null
      yo.campos = []
      yo.campo = null
      yo.turnos = []
      yo.turno = null
      yo.codigos_h = []
      yo.codigo_h = null
      yo.variedad = null
      yo.lote = null
      yo.valvula = null
      yo.area = null

      for(let value of yo.dataEmpresa){
        if(value.sociedad === yo.empresa && value.cultivo === yo.cultivo && value.fundo === yo.fundo){
          yo.etapas.push(value.etapa)
        }
      }

      yo.etapas = [... new Set(yo.etapas)]

    },

    asignarCampos(){
      const yo = this

      yo.campos = []
      yo.campo = null
      yo.turnos = []
      yo.turno = null
      yo.codigos_h = []
      yo.codigo_h = null
      yo.variedad = null
      yo.lote = null
      yo.valvula = null
      yo.area = null

      for(let value of yo.dataEmpresa){
        if(value.sociedad === yo.empresa && value.cultivo === yo.cultivo && value.fundo === yo.fundo && value.etapa === yo.etapa){
          yo.campos.push(value.campo)
        }
      }

      yo.campos = [... new Set(yo.campos)]

    },

    asignarTurnos(){
      const yo = this

      yo.turnos = []
      yo.turno = null
      yo.codigos_h = []
      yo.codigo_h = null
      yo.variedad = null
      yo.lote = null
      yo.valvula = null
      yo.area = null

      for(let value of yo.dataEmpresa){
        if(value.sociedad === yo.empresa && value.cultivo === yo.cultivo && value.fundo === yo.fundo && value.etapa === yo.etapa && value.campo === yo.campo){
          yo.turnos.push(value.turno)
        }
      }

      yo.turnos = [... new Set(yo.turnos)]

    },

    filtrarPorEstadoUno(){

      const yo = this
      let codhomo_filtrados = []
      let estado_uno_seleccionado
      if(yo.estado_lote == 0){
        estado_uno_seleccionado = 'ACTIVO'
      }else if(yo.estado_lote == 1){
        estado_uno_seleccionado = 'AGRUPADO'
      }else if(yo.estado_lote == 2){
        estado_uno_seleccionado = 'PENDIENTE'
      }


      for(let x of yo.codigos_h_resp){
        if(x['data']['estado_uno_texto'] === estado_uno_seleccionado){
          console.log(x)
          codhomo_filtrados.push(x)
        }
      }

      yo.codigos_h = []
      yo.codigo_h = ''
      yo.variedad = ''
      yo.lote = ''
      yo.valvula = ''
      yo.area = ''
      yo.codigos_h = codhomo_filtrados

    },

    asignarCodigos(){
      const yo = this

      yo.codigos_h = []
      yo.codigo_h = null
      yo.variedad = null
      yo.lote = null
      yo.valvula = null
      yo.area = null

      let s_cod_homologado = ''

      for(let value of yo.dataEmpresa){
        if(value.sociedad === yo.empresa && value.cultivo === yo.cultivo && value.fundo === yo.fundo && value.etapa === yo.etapa && value.campo === yo.campo && value.turno === yo.turno){ //0:Activo, 1:Agrupado

          s_cod_homologado = value.cod_homologado;
          yo.codigos_h.push({
            "codigo_h": value.cod_homologado,
            "data": {
              "codigo_h": value.cod_homologado_new,
              "cod_homologado": value.cod_homologado,
              "variedad": value.variedad,
              "area": value.area_ha,
              "lote": value.lote,
              "valvula": value.valvula,
              "estado_uno": value.estado_uno,
              "estado_uno_texto": value.estado_uno_texto,
            }
          })

        }
      }
      yo.codigos_h_resp = yo.codigos_h
      // yo.codigos_h = []
      // for(let value of yo.dataCompleta){

      //   if(value.sociedad === yo.empresa && value.cultivo === yo.cultivo && value.fundo === yo.fundo && value.etapa === yo.etapa && value.campo === yo.campo && value.turno === yo.turno && (value.estado === '0' || value.estado === '1')){

      //     s_cod_homologado = value.cod_homologado;
      //     yo.codigos_h.push({
      //       "codigo_h": value.cod_homologado_new,
      //       "data": {
      //         "codigo_h": value.cod_homologado_new,
      //         "cod_homologado": value.cod_homologado,
      //         "variedad": value.variedad,
      //         "area": value.area_sembrada,
      //         "lote": value.lote,
      //         "valvula": value.valvula,
      //       }
      //     })

      //   }
      // }

      // const filtro = yo.dataEmpresa.filter(
      //     invoice => invoice.cod_homologado === s_cod_homologado
      // )

      // yo.codigos_h.push({
      //   "codigo_h": filtro[0].cod_homologado,
      //   "data": {
      //     "codigo_h": filtro[0].cod_homologado,
      //     "cod_homologado": filtro[0].cod_homologado,
      //     "variedad": filtro[0].variedad,
      //     "area": filtro[0].area_total,
      //     "lote": filtro[0].lote,
      //     "valvula": filtro[0].valvula,
      //   }
      // })

      // yo.codigos_h.sort(function (a, b) {
      //   if (a.codigo_h > b.codigo_h) {
      //     return 1;
      //   }
      //   if (a.codigo_h < b.codigo_h) {
      //     return -1;
      //   }

      //   return 0;
      // })
    },

    seleccionarCodigoN(){
      const yo = this
      yo.variedad = null
      yo.lote = null
      yo.valvula = null
      yo.area = null

      yo.variedad = yo.codigo_h.variedad
      yo.area = yo.codigo_h.area
      yo.lote = yo.codigo_h.lote
      yo.valvula = yo.codigo_h.valvula
    },

    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    handleSubmit() {
      const yo = this
      this.$refs.formularioFertilizacion.validate().then(success => {
        if (success && !yo.mostrarAlert && !yo.mostrarAlert2)  {
          yo.loading2 = true

          const data = JSON.stringify({
            'semana': yo.semanaActual ? yo.semana : yo.semana_sig,
            'cultivo': yo.cultivo,
            // 'etapa_fen': 'PRODUCTIVA',
            'anio':yo.anio,
            'etapa_fen': yo.eta_fen_seleccionada,
            'por_concentracion': yo.por_concentracion,
            'empresa': yo.empresa,
            'fundo': yo.fundo,
            'etapa': yo.etapa,
            'campo': yo.campo,
            'turno': yo.turno,
            'variedad': yo.variedad,
            'lote': yo.lote,
            'valvula': yo.valvula,
            'area': yo.area,
            'cod_producto': yo.codigo,
            'producto': yo.producto,
            'grupo_producto': yo.grupo,
            'subgrupo_producto': null,
            'und_medida': yo.uni_med,
            'dias': yo.dias,
            'kg_ha_dia': yo.kg_ha_dia,
            'total_max_dia': yo.total_max_dia,
            'lun': yo.lunes,
            'mar': yo.martes,
            'mie': yo.miercoles,
            'jue': yo.jueves,
            'vie': yo.viernes,
            'sab': yo.sabado,
            'dom': yo.domingo,
            'estado': '0',
            'estado_lote': yo.estado_lote,
            'con_usuario': yo.id_user,
            'cod_homologado':yo.codigo_h['cod_homologado'],
            'parametros_usuario': JSON.stringify(yo.parametros_usuario),
          })
          // console.log("VICO")
          // console.log(data)
          const config = {
            method: 'post',
            url: 'pagricolas/fertilizacion/crear/',
            headers: {
              'Content-Type': 'application/json'
            },
            data: data
          }

          axiosIns(config)
              .then(function (response) {
                if (response.status === 200 ){
                  if(response.data['errores']){
                    let error=response.data['errores'][0]['error']
                    yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', error , 'warning', 6000)
                  }else{
                    yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se realizó de manera correcta", 'success', 5000)
                  }

                }

                if (response.status=== 202 ){
                  yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "El registro no se realizó porque los anteriores ya pasaron a estado Revisado", 'warning', 6000)
                }
              })
              .catch(function (error) {
                console.log(error);
                yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger', 5000)
              })
            .finally(function (){
            yo.traerFertilizaciones()
            yo.$nextTick(() => {
              yo.$refs['my-modal'].toggle('#toggle-btn')
            })
            yo.loading2 = false
          })

        }
      })
    },

    resetModal() {
      this.name = ''
      this.nameState = null

      this.cultivo= null
      this.empresa= null
      this.fundo= null
      this.etapa= null
      this.campo= null
      this.turno= null
      this.variedad= null
      this.lote= null
      this.valvula= null
      this.area= null
      this.codigo= null
      this.producto= null
      this.grupo= null
      this.uni_med= null
      this.dias= null
      this.kg_ha_dia= null
      this.total_max_dia= null
      this.lunes= null
      this.martes= null
      this.miercoles= null
      this.jueves= null
      this.viernes= null
      this.sabado= null
      this.domingo= null
      this.indicador= null

      this.mostrarAlert = false
      this.mostrarAlert2 = false

      this.dataInicial()

      this.semana = this.semanaActual ? this.semana : this.semana_sig
    },

    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },

    importarOk(bvModalEvtImp) {
      // Prevent modal from closing
      bvModalEvtImp.preventDefault()
      // Trigger submit handler
      this.enviarFile()
    },

    buscarProducto(){

      const yo = this
      yo.loadingBP = true

      const config = {
        method: 'get',
        url: '/pagricolas/consulta_productos/?codigo_producto='+ yo.codigo
      }

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              if (response.data['estado'] === true){
                yo.producto = response.data['producto']
                yo.grupo = response.data['grupo']
                yo.uni_med = response.data['un_medida']
              }else{
                yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "No se encontraron productos con el código ingresado.", 'warning', 2000)
                yo.producto = null
                yo.grupo = null
                yo.uni_med = null
              }
            }

          })
          .catch(function (error) {
            console.log(error);
            yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "No se encontraron productos con el código ingresado.", 'warning', 2000)
            yo.producto = null
            yo.grupo = null
            yo.uni_med = null
          })
          .finally(function (){
            yo.loadingBP = false
          })

      /*
      const data = this.productos[this.codigo]

      if (data !== undefined){
        this.producto = this.productos['2510041'][1]
        this.grupo = this.productos['2510041'][2]
        this.uni_med = this.productos['2510041'][4]
      }
      else{
        this.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "No se encontraron productos con el código ingresado.", 'warning', 2000)
        this.producto = null
        this.grupo = null
        this.uni_med = null
      }
      */
    },

    calcularMaxDia(){
      const kg = this.kg_ha_dia
      const are = this.area
      this.total_max_dia = (kg * are).toLocaleString('es-PE', {minimumFractionDigits: 2, maximumFractionDigits: 5})
    },

    mostrarNotificacion(titulo, icono, texto, variante, tiempo){
      this.$toast({
            component: ToastificationContent,
            props:{
              title: titulo,
              icon: icono,
              text: texto,
              variant: variante
            }
          },
          {
            timeout: tiempo,
            position: 'top-center',
          })
    },

    comporbarExcedente(){

      const suma = parseFloat(this.lunes) + parseFloat(this.martes) + parseFloat(this.miercoles) + parseFloat(this.jueves) + parseFloat(this.viernes) + parseFloat(this.sabado) + parseFloat(this.domingo)
      const resultado = (suma / parseInt(this.dias)).toLocaleString('es-PE', {maximumFractionDigits: 5})

      this.mostrarAlert = resultado !== this.total_max_dia;

      let c = 0

      c = parseFloat(this.lunes) !== 0 ? c+1 : c
      c = parseFloat(this.martes) !== 0 ? c+1 : c
      c = parseFloat(this.miercoles) !== 0 ? c+1 : c
      c = parseFloat(this.jueves) !== 0 ? c+1 : c
      c = parseFloat(this.viernes) !== 0 ? c+1 : c
      c = parseFloat(this.sabado) !== 0 ? c+1 : c
      c = parseFloat(this.domingo) !== 0 ? c+1 : c

      this.mostrarAlert2 = c !== parseInt(this.dias);

    },

    numeroDeSemana(fecha){
      const DIA_EN_MILISEGUNDOS = 1000 * 60 * 60 * 24, DIAS_QUE_TIENE_UNA_SEMANA = 7, JUEVES = 4;

      // fecha = new Date(Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()+7));
      fecha = new Date(Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()));

      let diaDeLaSemana = fecha.getUTCDay(); // Domingo es 0, sábado es 6
      if (diaDeLaSemana === 0) {
        diaDeLaSemana = 7;
      }

      fecha.setUTCDate(fecha.getUTCDate() - diaDeLaSemana + JUEVES);

      const inicioDelAnio = new Date(Date.UTC(fecha.getUTCFullYear(), 0, 1));

      const diferenciaDeFechasEnMilisegundos = fecha - inicioDelAnio;

      return {
        n_semana: Math.ceil(((diferenciaDeFechasEnMilisegundos / DIA_EN_MILISEGUNDOS) + 1) / DIAS_QUE_TIENE_UNA_SEMANA),
        inicio: new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate() - fecha.getDay() + 1),
        fin: new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate() + 7 - fecha.getDay()),
      }

    },

    asignarInicioFinSemana(){
      this.inicioSemana = ''
      this.finSemana = ''

      if (this.semana >= 1 && this.semana <= 52){
        const hoy = new Date()
        const fech = new Date(Date.UTC(hoy.getFullYear(), 0, 1));

        fech.setDate(fech.getDate() + (this.semana*7));

        const inicio = new Date(fech.getFullYear(), fech.getMonth(), fech.getDate() - fech.getDay() + 1)
        const fin = new Date(fech.getFullYear(), fech.getMonth(), fech.getDate() + 7 - fech.getDay())

        this.inicioSemana = inicio.toLocaleString('pe-PE', {
          month: 'long',
          day: '2-digit',
          year: 'numeric',
          localeMatcher: 'best fit',
          timeZone: 'America/Lima'
        })
        this.finSemana = fin.toLocaleString('pe-PE', {
          month: 'long',
          day: '2-digit',
          year: 'numeric',
          localeMatcher: 'best fit',
          timeZone: 'America/Lima'
        })
      }
    },

    enviarFile(){
      const yo = this
      this.$refs.formularioImportar.validate().then(success => {
        if (success) {
          this.loadingIMP = true
          const data = new FormData();
          data.append('file', yo.archivo_excel)
          data.append('con_usuario', yo.id_user)
          data.append('semana', yo.semanaEnviar)
          data.append('parametros_usuario', JSON.stringify(yo.parametros_usuario))

          const config = {
            method: 'post',
            url: '/pagricolas/cargar_excel_pag/',
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data: data
          }

          axiosIns(config)
              .then(function (response) {
                if(response.status === 200){
                  yo.traerFertilizaciones()

                  yo.respuestaRegistrosTotal = response.data['total']
                  yo.respuestaErrores = response.data['errores']

                }
              })
              .catch(function (error) {
                console.log(error);

                yo.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Error en el registro',
                    icon: 'XIcon',
                    text: 'Hubo un error en el registro, intentelo nuevamente en unos minutos.',
                    variant: 'danger',
                  },
                })
              })
              .finally(function () {
                yo.archivo_excel = null
                yo.cultivoIMP = null
                yo.loadingIMP = false
                yo.$nextTick(() => {
                  yo.$refs['modal-importar'].toggle('#toggle-btn')
                })

                yo.estadoModalRespuesta = true
              })
        }
      })
    },

    autorizar(data){
      const yo=this;
      this.estado_aprobar = null
      let conta=0;

      if(data['estado'] === '5'){
        if(yo.responsable[0].rol === 'JEFE DE RIEGO' || yo.responsable[0].rol === 'USUARIO'){
          this.mostrarNotificacion('Advertencia', 'BellIcon', "No tienes permisos para modificar el estado de este registro.", 'warning', 6000)
          conta = conta + 1
        }
      }else if(data['estado'] === '1' || data['estado'] === '2' || data['estado'] === '3'){
        if(yo.responsable[0].rol === 'USUARIO'){
          this.mostrarNotificacion('Advertencia', 'BellIcon', "No tienes permisos para modificar el estado de este registro.", 'warning', 6000)
          conta = conta + 1
        }
      }

      if (conta<1){
        this.modalEditarEstadoShow = true
        this.dataAutorizar = data.semana + "*" + data.cultivo + "*" + data.empresa + "*" + data.fundo + "*" + data.version
      }

      // if(data['estado'] === '0'){
      //   this.modalEditarEstadoShow = true
      //   this.dataAutorizar = data.semana + "*" + data.cultivo + "*" + data.empresa + "*" + data.fundo + "*" + data.version
      // }else{
      //   if(this.responsable[0].rol === 'USUARIO'){
      //     this.mostrarNotificacion('Advertencia', 'BellIcon', "Solo se pueden seleccionar los registro con aprobación pendiente.", 'warning', 6000)
      //   }else{
      //     this.modalEditarEstadoShow = true
      //     this.dataAutorizar = data.semana + "*" + data.cultivo + "*" + data.empresa + "*" + data.fundo + "*" + data.version
      //   }
      // }
    },

    verDetalle(datos){
      const yo = this
      yo.items_sem_act = yo.spd.filter(invoice => invoice.semana+invoice.cultivo+invoice.empresa+invoice.version === datos.semana+datos.cultivo+datos.empresa+datos.version)

      yo.mostrarSemAct = true
    },

    verDetalleSemSgte(datos){
      const yo = this
      yo.items_sem_sgte = yo.spd.filter(invoice => invoice.semana+invoice.cultivo+invoice.empresa+invoice.version === datos.semana+datos.cultivo+datos.empresa+datos.version)

      yo.mostrarSemSgte = true
    },

    asignarMaxDiaSemana(){
      const yo = this
      yo.lunes = '0.0'
      yo.martes = '0.0'
      yo.miercoles = '0.0'
      yo.jueves = '0.0'
      yo.viernes = '0.0'
      yo.sabado = '0.0'
      yo.domingo = '0.0'

      if (yo.dias >= 1 && yo.dias <= 7){
        for (let i = 1; i<=7; i++){
          if (i<=yo.dias && i===1){
            yo.lunes = yo.total_max_dia
          }

          if (i<=yo.dias && i===2){
            yo.martes = yo.total_max_dia
          }

          if (i<=yo.dias && i===3){
            yo.miercoles = yo.total_max_dia
          }

          if (i<=yo.dias && i===4){
            yo.jueves = yo.total_max_dia
          }

          if (i<=yo.dias && i===5){
            yo.viernes = yo.total_max_dia
          }

          if (i<=yo.dias && i===6){
            yo.sabado = yo.total_max_dia
          }

          if (i<=yo.dias && i===7){
            yo.domingo = yo.total_max_dia
          }

        }
      }
    },

    descargarPlantilla(){
      const yo = this
      const config = {
        method: 'get',
        url: '/pagricolas/fertilizacion/plantilla/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer'
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {

              const fileURL = window.URL.createObjectURL(new Blob([response.data]))
              const fileLink = document.createElement('a')
              fileLink.href = fileURL;
              fileLink.setAttribute('download', 'Plantilla_PRG_AGR.xlsx');
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Archivo creado',
                      icon: 'CheckIcon',
                      text: 'El archivo se creó satisfactoriamente.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          });
    },

    validarEditar(datos, a_s) {
      const yo = this

      if (datos['estado'] === '0' || datos['estado'] === '3') {
        const config = {
          method: 'get',
          url: '/pagricolas/parametrosCompleto/?cod=' + yo.id_user
        }

        axiosIns(config)
            .then(function (response) {
              if(response.status === 200){

                yo.parametros_usuario = response.data['usuario'][0]
                const parametros_total = response.data['parametros'].filter(
                    invoice => invoice.id === 4
                );
                const parametros_actual = response.data['parametros'].filter(
                    invoice => invoice.id === 5
                );
                const parametros_sgte = response.data['parametros'].filter(
                    invoice => invoice.id === 6
                );

                if(parametros_total[0]['estado'] === '0'){
                  yo.parametros = parametros_total
                }
                else if (a_s){
                  if(parametros_actual[0]['estado'] === '0'){
                    yo.parametros = parametros_actual
                  }else{
                    yo.parametros = [{
                      'valor': response.data['usuario'][0]['valor'],
                      'valor2': response.data['usuario'][0]['valor_1']
                    }]
                  }
                }
                else{
                  if(parametros_sgte[0]['estado'] === '0'){
                    yo.parametros = parametros_sgte
                  }else{
                    yo.parametros = [{
                      'valor': response.data['usuario'][0]['valor_2'],
                      'valor2': response.data['usuario'][0]['valor_3']
                    }]
                  }
                }

                yo.dia = yo.parametros[0]['valor']
                yo.hora = yo.parametros[0]['valor2']
                let valorDia = 0

                const horaInicial = yo.hora.split(':')

                if(yo.dia === 'LUNES'){
                  valorDia = 1
                }else if(yo.dia === 'MARTES'){
                  valorDia = 2
                }else if(yo.dia === 'MIÉRCOLES'){
                  valorDia = 3
                }else if(yo.dia === 'JUEVES'){
                  valorDia = 4
                }else if(yo.dia === 'VIERNES'){
                  valorDia = 5
                }else if(yo.dia === 'SÁBADO'){
                  valorDia = 6
                }else if(yo.dia === 'DOMINGO'){
                  valorDia = 7
                }

                const ahora = new Date()

                const fechaInicial = new Date(ahora.getUTCFullYear(), ahora.getUTCMonth(),ahora.getUTCDate(), parseInt(horaInicial[0]), parseInt(horaInicial[1]), parseInt(horaInicial[2]))

                if (ahora.getDay() < valorDia){
                  yo.mostrarModalEditar(datos)
                }else if(ahora.getDay() === valorDia){
                  if(ahora <= fechaInicial){
                    yo.mostrarModalEditar(datos)
                  }else{
                    yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "No pueden agregar nuevos registros porque se encuentra fuera del límite programado.", 'warning', 5000)
                  }
                }else{
                  yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "No pueden agregar nuevos registros porque se encuentra fuera del límite programado.", 'warning', 5000)
                }
              }
            })
            .catch(function (error) {
              console.log(error);
            })
            .finally(function (){
              yo.loading = false
            })
      }
      else{
        this.mostrarNotificacion('Advertencia', 'BellIcon', "Solo se pueden editar los registro pendientes u observados.", 'warning', 6000)
      }
    },

    mostrarModalEditar(datos){
      const yo = this
      yo.estadoModalEditar = true
      yo.id_editar = datos['id']
      yo.semana = datos['semana']
      yo.codigo = datos['cod_producto']
      yo.producto = datos['producto']
      yo.grupo = datos['grupo_producto']
      yo.uni_med = datos['und_medida']
      yo.kg_ha_dia = datos['kg_ha_dia']
      yo.total_max_dia = datos['total_max_dia']
      yo.dias = datos['dias']
      yo.lunes = datos['lun']
      yo.martes = datos['mar']
      yo.miercoles = datos['mie']
      yo.jueves = datos['jue']
      yo.viernes = datos['vie']
      yo.sabado = datos['sab']
      yo.domingo = datos['dom']
      yo.eta_fen_seleccionada = datos['etapa_fen']
      yo.por_concentracion = datos['por_concentracion']
      yo.empresa = datos['empresa']
      yo.asignarCultivos()
      yo.cultivo = datos['cultivo']
      yo.asignarFundos()
      yo.fundo = datos['fundo']
      yo.asignarEtapas()
      yo.etapa = datos['etapa']
      yo.asignarCampos()
      yo.campo = datos['campo']
      yo.asignarTurnos()
      yo.turno = datos['turno']
      yo.asignarCodigos()
      yo.estado_lote = datos['estado_lote']
      yo.filtrarPorEstadoUno()

      for(let x of yo.codigos_h){
        if(x['data']['lote'] == datos['lote']
          && x['data']['valvula'] == datos['valvula']
          && x['data']['area'] == datos['area']){
            yo.codigo_h = x
        }

      }

      yo.variedad = datos['variedad']
      yo.lote = datos['lote']
      yo.valvula = datos['valvula']
      yo.area = datos['area']

    },

    mostrarModalImportar(valor){

      const yo = this
      const config = {
        method: 'get',
        url: '/pagricolas/parametrosCompleto/?cod=' + yo.id_user
      }

      yo.loadingSAM = valor
      yo.loadingSSM = !valor

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.parametros_usuario = response.data['usuario'][0]
              const parametros_total = response.data['parametros'].filter(
                  invoice => invoice.id === 4
              );
              const parametros_actual = response.data['parametros'].filter(
                  invoice => invoice.id === 5
              );
              const parametros_sgte = response.data['parametros'].filter(
                  invoice => invoice.id === 6
              );

              if(parametros_total[0]['estado'] === '0'){
                yo.parametros = parametros_total
              }
              else if (valor){
                if(parametros_actual[0]['estado'] === '0'){
                  yo.parametros = parametros_actual
                }else{
                  yo.parametros = [{
                    'valor': response.data['usuario'][0]['valor'],
                    'valor2': response.data['usuario'][0]['valor_1']
                  }]

                }
              }
              else{
                if(parametros_sgte[0]['estado'] === '0'){
                  yo.parametros = parametros_sgte
                }else{
                  yo.parametros = [{
                    'valor': response.data['usuario'][0]['valor_2'],
                    'valor2': response.data['usuario'][0]['valor_3']
                  }]
                }
              }

              yo.semanaEnviar = valor ? yo.semana : yo.semana_sig

              yo.dia = yo.parametros[0]['valor']
              yo.hora = yo.parametros[0]['valor2']

              let valorDia = 0

              const horaInicial = yo.hora.split(':')

              if(yo.dia === 'LUNES'){
                valorDia = 1
              }else if(yo.dia === 'MARTES'){
                valorDia = 2
              }else if(yo.dia === 'MIÉRCOLES'){
                valorDia = 3
              }else if(yo.dia === 'JUEVES'){
                valorDia = 4
              }else if(yo.dia === 'VIERNES'){
                valorDia = 5
              }else if(yo.dia === 'SÁBADO'){
                valorDia = 6
              }else if(yo.dia === 'DOMINGO'){
                valorDia = 7
              }

              const ahora = new Date()

              const fechaInicial = new Date(ahora.getUTCFullYear(), ahora.getUTCMonth(),ahora.getUTCDate(), parseInt(horaInicial[0]), parseInt(horaInicial[1]), parseInt(horaInicial[2]))

              if (ahora.getDay() < valorDia){
                yo.estadoModalImportar = true
              }
              else if (ahora.getDay() === valorDia){
                if(ahora <= fechaInicial){
                  yo.estadoModalImportar = true
                }else{
                  yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "No pueden agregar nuevos registros porque se encuentra fuera del límite programado.", 'warning', 5000)
                }
              }else{
                yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "No pueden agregar nuevos registros porque se encuentra fuera del límite programado.", 'warning', 5000)
              }
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){
            yo.loadingSAM = false
            yo.loadingSSM = false
          })

    },

    filtros(){
      this.items = this.spd
      this.items = this.items.filter(
          invoice =>
              invoice.empresa === (this.empresaFiltro || invoice.empresa) &&
              invoice.semana === (this.semanaFiltro || invoice.semana) &&
              invoice.cultivo === (this.cultivoFiltro || invoice.cultivo)
      )
      this.totalRows = this.items.length
    },

    buscarResponsable(){
      return new Promise(resolve => {
        const yo = this
        yo.loading = true

        const config = {
          method: 'get',
          url: '/pagricolas/consulta_responsable/?id='+ yo.id_user
        }

        let spd = []

        axiosIns(config)
            .then(function (response) {
              if(response.status === 200){

                yo.responsable = response.data
                // console.log(yo.responsable[0].rol)
                spd = response.data
              }

            })
            .catch(function (error) {
              console.log(error);
              yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "No se encontraron datos con el usuario ingresado.", 'warning', 2000)
            })
            .finally(function (){
              resolve()
            })
      });
    },

    aprobar(){
      const yo = this

      const config = {
        method: 'get',
        url: '/pagricolas/editar_estado/?datos='+ yo.dataAutorizar + "*" + yo.estado_aprobar
      }

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se actualizó de manera correcta", 'success', 5000)
            }

          })
          .catch(function (error) {
            console.log(error);
            yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "No se encontraron productos con el código ingresado.", 'warning', 2000)
          })
          .finally(function (){
            yo.traerFertilizaciones()
          })
    },

    modal_registro(valor){
      const yo = this
      const config = {
        method: 'get',
        url: '/pagricolas/parametrosCompleto/?cod=' + yo.id_user
      }

      yo.loadingSAC = valor
      yo.loadingSSC = !valor

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.parametros_usuario = response.data['usuario'][0]
              const parametros_total = response.data['parametros'].filter(invoice => invoice.id === 4);
              const parametros_actual = response.data['parametros'].filter(invoice => invoice.id === 5);
              const parametros_sgte = response.data['parametros'].filter(invoice => invoice.id === 6);

              if(parametros_total[0]['estado'] === '0'){
                yo.parametros = parametros_total
              }
              else if (valor){
                if(parametros_actual[0]['estado'] === '0'){
                  yo.parametros = parametros_actual
                }else{
                  yo.parametros = [{
                    'valor': response.data['usuario'][0]['valor'],
                    'valor2': response.data['usuario'][0]['valor_1']
                  }]
                }
              }
              else{
                if(parametros_sgte[0]['estado'] === '0'){
                  yo.parametros = parametros_sgte
                }else{
                  yo.parametros = [{
                    'valor': response.data['usuario'][0]['valor_2'],
                    'valor2': response.data['usuario'][0]['valor_3']
                  }]
                }
              }

              if(valor) {
                yo.title_sem = `Ingresar nueva programación - Semana ${yo.semana} - Del ${yo.inicioSemana} al ${yo.finSemana}`
                yo.semanaActual = true
              }else{
                yo.title_sem = `Ingresar nueva programación - Semana ${yo.semana_sig} - Del ${yo.inicioSemana_sig} al ${yo.finSemana_sig}`
                yo.semanaActual = false
              }

              yo.dia = yo.parametros[0]['valor']
              yo.hora = yo.parametros[0]['valor2']
              let valorDia = 0

              const horaInicial = yo.hora.split(':')

              if(yo.dia === 'LUNES'){
                valorDia = 1
              }else if(yo.dia === 'MARTES'){
                valorDia = 2
              }else if(yo.dia === 'MIÉRCOLES'){
                valorDia = 3
              }else if(yo.dia === 'JUEVES'){
                valorDia = 4
              }else if(yo.dia === 'VIERNES'){
                valorDia = 5
              }else if(yo.dia === 'SÁBADO'){
                valorDia = 6
              }else if(yo.dia === 'DOMINGO'){
                valorDia = 7
              }

              const ahora = new Date()

              const fechaInicial = new Date(ahora.getUTCFullYear(), ahora.getUTCMonth(),ahora.getUTCDate(), parseInt(horaInicial[0]), parseInt(horaInicial[1]), parseInt(horaInicial[2]))

              if (ahora.getDay() < valorDia){
                yo.modal_registro_o = true
              }
              else if (ahora.getDay() === valorDia){
                if(ahora <= fechaInicial){
                  yo.modal_registro_o = true
                }else{
                  yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "No pueden agregar nuevos registros porque se encuentra fuera del límite programado.", 'warning', 5000)
                }
              }else{
                yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "No pueden agregar nuevos registros porque se encuentra fuera del límite programado.", 'warning', 5000)
              }
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){
            yo.loadingSAC = false
            yo.loadingSSC = false
          })
    },

    descargarRegistros(valor){
      const yo = this
      let datos=[]
      const semmm = valor ? yo.semana : yo.semana_sig

      if (yo.responsable[0].rol === 'JEFE DE RIEGO CORPORATIVO'){
        // datos = yo.items_completo.filter(invoice => invoice.semana === semmm && (invoice.estado === '2' || invoice.estado === '5'))
        // datos = yo.items.filter(invoice => invoice.semana === semmm && (invoice.estado === '2' || invoice.estado === '5'))
        datos = yo.spd.filter(invoice => invoice.semana === semmm && (invoice.estado === '2' || invoice.estado === '5'))
      }else{
        // datos = yo.items_completo.filter(invoice => invoice.semana === semmm)
        // datos = yo.items.filter(invoice => invoice.semana === semmm)
        datos = yo.spd.filter(invoice => invoice.semana === semmm)
      }

      if (datos.length > 0){
        yo.loadingSAD = valor
        yo.loadingSSD = !valor
        let selectedIds = datos.map(item => item.id);

        const data = JSON.stringify(
            {
              // "datas":datos,
              "ids" : selectedIds,
              "id_user": yo.id_user
            }
        )

        const config = {
          method: 'post',
          url: '/pagricolas/fertilizacion/exportar/filter/',
          headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'arraybuffer',
          data : data
        };

        axiosIns(config)
            .then(function (response) {
              if (response.status === 200) {
                const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                const fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', "Exportar detalle fertilizacion - semana "+ semmm +".xlsx");
                document.body.appendChild(fileLink);
                fileLink.click();

                yo.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Archivo creado',
                        icon: 'CheckIcon',
                        text: 'El archivo se creó satisfactoriamente.',
                        variant: 'success',
                      },
                    },
                    {
                      position: 'top-center',
                    })
              }
            })
            .catch(function (error) {
              console.log(error);
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Error en la creación del archivo',
                  icon: 'XIcon',
                  text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                  variant: 'danger',
                },
              })
            })
            .finally(function () {
              yo.loadingSAD = false
              yo.loadingSSD = false
            });
      }
      else{
        yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Advertencia',
                icon: 'CheckIcon',
                text: 'No se encontraron registros.',
                variant: 'warning',
              },
            },
            {
              position: 'top-center',
            })
      }
    },

    descargarRegistros2(valor){
      const yo = this

      const semmm = valor ? yo.semana : yo.semana_sig
      const datos = yo.items_completo.filter(invoice => invoice.semana === semmm && (invoice.estado === '1' || invoice.estado === '2'))

      if (datos.length > 0){
        yo.loadingSAD = valor
        yo.loadingSSD = !valor

        const data = JSON.stringify(
            {
              "datas":datos,
              "id_user": yo.id_user
            }
        )

        const config = {
          method: 'post',
          url: '/pagricolas/fertilizacion/exportar/filter/',
          headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'arraybuffer',
          data : data
        };

        axiosIns(config)
            .then(function (response) {
              if (response.status === 200) {
                const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                const fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', "Exportar detalle fertilizacion - semana "+ semmm +".xlsx");
                document.body.appendChild(fileLink);
                fileLink.click();

                yo.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Archivo creado',
                        icon: 'CheckIcon',
                        text: 'El archivo se creó satisfactoriamente.',
                        variant: 'success',
                      },
                    },
                    {
                      position: 'top-center',
                    })
              }
            })
            .catch(function (error) {
              console.log(error);
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Error en la creación del archivo',
                  icon: 'XIcon',
                  text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                  variant: 'danger',
                },
              })
            })
            .finally(function () {
              yo.loadingSAD = false
              yo.loadingSSD = false
            });
      }
      else{
        yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Advertencia',
                icon: 'CheckIcon',
                text: 'No se encontraron registros.',
                variant: 'warning',
              },
            },
            {
              position: 'top-center',
            })
      }
    }

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: '';
}


.tablaferti{
  min-height: 52vh!important;
}

.tablaferti::-webkit-scrollbar {
  width: 1.35vh;
  height: 1.35vh;
}
.tablaferti::-webkit-scrollbar-track {
  background-color: rgba(171, 171, 171, 0.35);
  border-radius: 6px;
  position: absolute;
}
.tablaferti::-webkit-scrollbar-thumb {
  background-image: linear-gradient(47deg, #82868b, #9ca0a4);
  border-radius: 6px;
  position: absolute;
}

</style>
